// Set de iconos del Design System (ECI). Cada icono es un Server Component fino
// sobre el primitivo `SvgIcon`, que aporta tamaño, `currentColor` y accesibilidad.
// Los trazados (`d`) y `viewBox` se preservan del diseño original (Figma).
//
// Por defecto los iconos son DECORATIVOS (`aria-hidden`). Para un icono
// informativo (p. ej. único contenido de un botón), pasar `label`:
//   <IconSearch label="Buscar" />

import { SvgIcon, type IconProps } from './Icon'

export type { IconProps }

export const IconSearch = (p: IconProps) => (
  <SvgIcon {...p} viewBox="0 0 19.5243 19.5243">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.6 0C3.40264 0 0 3.40264 0 7.6C0 11.7974 3.40264 15.2 7.6 15.2C9.4827 15.2 11.2055 14.5154 12.5331 13.3816L18.6758 19.5243L19.5243 18.6758L13.3816 12.5331C14.5154 11.2055 15.2 9.4827 15.2 7.6C15.2 3.40264 11.7974 0 7.6 0ZM1.2 7.6C1.2 4.06538 4.06538 1.2 7.6 1.2C11.1346 1.2 14 4.06538 14 7.6C14 11.1346 11.1346 14 7.6 14C4.06538 14 1.2 11.1346 1.2 7.6Z"
      fill="currentColor"
    />
  </SvgIcon>
)

export const IconClose = (p: IconProps) => (
  <SvgIcon {...p} viewBox="0 0 16.0514 16.0514">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.17731 8.02584L0 0.848528L0.848528 0L8.02584 7.17732L15.203 6.82622e-05L16.0514 0.848546L8.87426 8.02573L16.0514 15.2029L15.2029 16.0514L8.02573 8.87426L0.848648 16.0513L0.000180542 15.203L7.17731 8.02584Z"
      fill="currentColor"
    />
  </SvgIcon>
)

export const IconChevDown = (p: IconProps) => (
  <SvgIcon {...p} viewBox="0 0 15.8485 8.77279">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0 0.848528L0.848528 0L7.92426 7.07574L15 0L15.8485 0.848528L7.92426 8.77279L0 0.848528Z"
      fill="currentColor"
    />
  </SvgIcon>
)

export const IconChevLeft = (p: IconProps) => (
  <SvgIcon {...p} viewBox="0 0 8.77279 15.8485">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.92426 0L8.77279 0.848528L1.69706 7.92426L8.77279 15L7.92426 15.8485L0 7.92426L7.92426 0Z"
      fill="currentColor"
    />
  </SvgIcon>
)

export const IconChevRight = (p: IconProps) => (
  <SvgIcon {...p} viewBox="0 0 8.77279 15.8485">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.848528 0L0 0.848528L7.07574 7.92426L0 15L0.848528 15.8485L8.77279 7.92426L0.848528 0Z"
      fill="currentColor"
    />
  </SvgIcon>
)

export const IconChevUp = (p: IconProps) => (
  <SvgIcon {...p} viewBox="0 0 15.8485 8.77279">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.8485 7.92426L15 8.77279L7.92426 1.69706L0.848528 8.77279L0 7.92426L7.92426 0L15.8485 7.92426Z"
      fill="currentColor"
    />
  </SvgIcon>
)

export const IconMenu = (p: IconProps) => (
  <SvgIcon {...p} viewBox="0 0 20 13.2">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20 1.2H0V0H20V1.2ZM20 7.2H0V6H20V7.2ZM20 13.2H0V12H20V13.2Z"
      fill="currentColor"
    />
  </SvgIcon>
)

export const IconCheck = (p: IconProps) => (
  <SvgIcon {...p} viewBox="0 0 19.3485 13.7728">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19.3485 0.848528L6.42426 13.7728L0 7.34853L0.848528 6.5L6.42426 12.0757L18.5 0L19.3485 0.848528Z"
      fill="currentColor"
    />
  </SvgIcon>
)

export const IconAdd = (p: IconProps) => (
  <SvgIcon {...p} viewBox="0 0 19 19">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.9 8.9V0H10.1V8.9H19V10.1H10.1V19H8.9V10.1H0V8.9H8.9Z"
      fill="currentColor"
    />
  </SvgIcon>
)

export const IconRemove = (p: IconProps) => (
  <SvgIcon {...p} viewBox="0 0 19 1.2">
    <path fillRule="evenodd" clipRule="evenodd" d="M19 1.2H0V0H19V1.2Z" fill="currentColor" />
  </SvgIcon>
)

export const IconFilter = (p: IconProps) => (
  <SvgIcon {...p} viewBox="0 0 20 19.2">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.70005 0C11.0682 0 12.2112 0.964099 12.4868 2.25L20 2.25V3.45L12.4868 3.45C12.2112 4.7359 11.0682 5.7 9.70005 5.7C8.33184 5.7 7.18882 4.73588 6.91331 3.44995H0V2.24995H6.91333C7.18888 0.964075 8.33188 0 9.70005 0ZM11.35 2.85C11.35 1.93873 10.6113 1.2 9.70005 1.2C8.78878 1.2 8.05005 1.93873 8.05005 2.85C8.05005 3.76127 8.78878 4.5 9.70005 4.5C10.6113 4.5 11.35 3.76127 11.35 2.85Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.7 6.75C15.0682 6.75 16.2112 7.7141 16.4868 9H19.95V10.2H16.4868C16.2112 11.4859 15.0682 12.45 13.7 12.45C12.3318 12.45 11.1888 11.4859 10.9133 10.2H0.000244141V8.99995H10.9133C11.1889 7.71407 12.3319 6.75 13.7 6.75ZM15.35 9.6C15.35 8.68873 14.6113 7.95 13.7 7.95C12.7888 7.95 12.05 8.68873 12.05 9.6C12.05 10.5113 12.7888 11.25 13.7 11.25C14.6113 11.25 15.35 10.5113 15.35 9.6Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.70005 13.5C8.06831 13.5 9.21136 14.4642 9.48682 15.7502H20V16.9502H9.48674C9.21113 18.236 8.06817 19.2 6.70005 19.2C5.33184 19.2 4.18882 18.2359 3.91331 16.95H0V15.75H3.91333C4.18888 14.4641 5.33188 13.5 6.70005 13.5ZM6.70005 14.7C7.61132 14.7 8.35005 15.4387 8.35005 16.35C8.35005 17.2613 7.61132 18 6.70005 18C5.78878 18 5.05005 17.2613 5.05005 16.35C5.05005 15.4387 5.78878 14.7 6.70005 14.7Z"
      fill="currentColor"
    />
  </SvgIcon>
)

export const IconLocation = (p: IconProps) => (
  <SvgIcon {...p} viewBox="0 0 15.2 21.4">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.6 3.98772C5.61177 3.98772 4 5.59454 4 7.57666C4 9.55878 5.61177 11.1656 7.6 11.1656C9.58822 11.1656 11.2 9.55878 11.2 7.57666C11.2 5.59454 9.58822 3.98772 7.6 3.98772ZM5.2 7.57666C5.2 6.25525 6.27452 5.18403 7.6 5.18403C8.92548 5.18403 10 6.25525 10 7.57666C10 8.89807 8.92548 9.96929 7.6 9.96929C6.27452 9.96929 5.2 8.89807 5.2 7.57666Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.6 0C5.58565 0 3.6529 0.8297 2.22725 2.30799C0.801507 3.78636 0 5.79211 0 7.88413C0 10.9491 1.8976 14.3187 3.78262 16.9128C4.72668 18.212 5.67058 19.3206 6.3784 20.1044C6.69593 20.456 6.96601 20.7423 7.16738 20.9512L7.6 21.4L8.03262 20.9512C8.23399 20.7423 8.50407 20.456 8.8216 20.1044C9.52942 19.3206 10.4733 18.212 11.4174 16.9128C13.3024 14.3187 15.2 10.9491 15.2 7.88413C15.2 5.79211 14.3985 3.78636 12.9728 2.30799C11.5471 0.8297 9.61435 0 7.6 0ZM3.09229 3.13712C4.29683 1.88811 5.91943 1.19631 7.6 1.19631C9.28057 1.19631 10.9032 1.88811 12.1077 3.13712C13.3139 4.38787 14 6.09458 14 7.88413C14 10.5386 12.3158 13.6373 10.4456 16.211C9.53275 17.4672 8.61749 18.5424 7.92978 19.304C7.81271 19.4336 7.70239 19.554 7.6 19.6644C7.49761 19.554 7.38729 19.4336 7.27022 19.304C6.58251 18.5424 5.66725 17.4672 4.75442 16.211C2.88424 13.6373 1.2 10.5386 1.2 7.88413C1.2 6.09458 1.88606 4.38787 3.09229 3.13712Z"
      fill="currentColor"
    />
  </SvgIcon>
)

export const IconCalendar = (p: IconProps) => (
  <SvgIcon {...p} viewBox="0 0 22 20.5">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.5999 0V1.5H15.3999V0H16.5999V1.5H22V20.5H0V1.5H5.3999V0H6.5999ZM15.3999 2.7V4H16.5999V2.7H20.8V6.90002H1.2V2.7H5.3999V4H6.5999V2.7H15.3999ZM20.8 8.10002H1.2V19.3H20.8V8.10002Z"
      fill="currentColor"
    />
  </SvgIcon>
)

export const IconHeart = (p: IconProps) => (
  <SvgIcon {...p} viewBox="0 0 20.1996 21.563">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.3733 0.460957C14.0877 -0.23086 16.2256 -0.281996 18.2104 1.27809L18.2297 1.29324L18.2485 1.30894C19.8893 2.67915 20.3737 4.48267 20.1471 6.29445C19.9333 8.00309 19.0951 9.74636 18.1063 11.3397C16.6816 13.6353 14.7115 15.9707 13.1059 17.8738L13.0782 17.9067C12.4502 18.6511 11.8815 19.3254 11.4071 19.9205L10.0977 21.563L8.79032 19.9189C8.31242 19.318 7.73782 18.636 7.10275 17.8825L7.08925 17.8665L7.07515 17.8497C5.47541 15.9516 3.51523 13.6258 2.0959 11.3401C1.10661 9.74694 0.267538 8.00379 0.0529237 6.29526C-0.17466 4.48347 0.308852 2.67958 1.95003 1.30904L1.9689 1.29329L1.98823 1.2781C3.98487 -0.291254 6.14021 -0.210269 7.84753 0.485791C8.7078 0.836516 9.46876 1.34313 10.094 1.87723C10.7281 1.32969 11.4995 0.813526 12.3733 0.460957ZM17.4689 2.22154C15.8848 0.976474 14.2184 1.01043 12.8223 1.57377C11.9244 1.9361 11.1317 2.51728 10.5152 3.1188L10.0984 3.52552L9.67944 3.12103C9.07126 2.53386 8.285 1.96004 7.39451 1.59699C5.99647 1.02703 4.31717 0.973868 2.72979 2.22154L2.72443 2.22575L2.71921 2.23011C1.44215 3.29658 1.05811 4.6693 1.24357 6.1457C1.42588 7.59706 2.15699 9.16373 3.11534 10.707C4.48459 12.9121 6.39218 15.1773 8.00684 17.0931L8.02034 17.1092C8.65213 17.8588 9.23888 18.555 9.72954 19.172L10.0989 19.6365L10.4688 19.1725C10.9556 18.5618 11.5358 17.874 12.1606 17.1335L12.1746 17.1169C13.7951 15.1959 15.7123 12.9215 17.0867 10.7069C18.0445 9.16358 18.7748 7.59688 18.9564 6.14549C19.1411 4.66913 18.7564 3.29648 17.4794 2.2301L17.4742 2.22575L17.4689 2.22154Z"
      fill="currentColor"
    />
  </SvgIcon>
)

export const IconHeartFilled = (p: IconProps) => (
  <SvgIcon {...p} viewBox="0 0 20.1996 21.563">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18.2104 1.27809C16.2256 -0.281996 14.0877 -0.23086 12.3733 0.460957C11.4995 0.813526 10.7281 1.32969 10.094 1.87723C9.46876 1.34313 8.7078 0.836516 7.84753 0.485791C6.14021 -0.210269 3.98487 -0.291254 1.98823 1.2781L1.9689 1.29329L1.95003 1.30904C0.308852 2.67958 -0.17466 4.48347 0.0529237 6.29526C0.267538 8.00379 1.10661 9.74694 2.0959 11.3401C3.51523 13.6258 5.47541 15.9516 7.07515 17.8497L7.10275 17.8825C7.73782 18.636 8.31242 19.318 8.79032 19.9189L10.0977 21.563L11.4071 19.9205C11.8815 19.3254 12.4502 18.6511 13.0782 17.9067L13.1059 17.8738C14.7115 15.9707 16.6816 13.6353 18.1063 11.3397C19.0951 9.74636 19.9333 8.00309 20.1471 6.29445C20.3737 4.48267 19.8893 2.67915 18.2485 1.30894L18.2297 1.29324L18.2104 1.27809Z"
      fill="currentColor"
    />
  </SvgIcon>
)

// ─── Flechas / navegación ─────────────────────────────────────────────────────

export const IconArrowLeft = (p: IconProps) => (
  <SvgIcon {...p} viewBox="0 0 18.3485 13.8485">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.29706 6.32426L18.3485 6.32426V7.52426L2.29706 7.52426L7.77279 13L6.92426 13.8485L0 6.92426L6.92426 0L7.77279 0.848528L2.29706 6.32426Z"
      fill="currentColor"
    />
  </SvgIcon>
)

export const IconArrowRight = (p: IconProps) => (
  <SvgIcon {...p} viewBox="0 0 18.3485 13.8485">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.0515 6.32426L0 6.32426L5.24537e-08 7.52426L16.0515 7.52426L10.5757 13L11.4243 13.8485L18.3485 6.92426L11.4243 0L10.5757 0.848528L16.0515 6.32426Z"
      fill="currentColor"
    />
  </SvgIcon>
)

// ─── Usuario ──────────────────────────────────────────────────────────────────

/**
 * Busto del acceso a cuenta de elcorteingles.es (`_profile_white.svg`): solo
 * trazo, fondo transparente. Sin sesión. El blanco fijo del original se
 * sustituye por `currentColor`.
 */
export const IconProfile = (p: IconProps) => (
  <SvgIcon {...p} viewBox="0 0 25.05 25.002">
    <g
      transform="translate(-1100.475 -137.5)"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1}
    >
      <circle cx="5.551" cy="5.551" r="5.551" transform="translate(1107.21 138)" />
      <path
        d="M94.163,48.555l-1.529.224a16.628,16.628,0,0,1-5.117-.045l-1.089-.179a6.145,6.145,0,0,0-5.21,2.629L78.53,55.418c-.7,1.106.25,2.442,1.737,2.442h20.055c1.488,0,2.438-1.336,1.737-2.442l-2.689-4.234A6.14,6.14,0,0,0,94.163,48.555Z"
        transform="translate(1022.705 104.143)"
      />
    </g>
  </SvgIcon>
)

/**
 * Variante con sesión iniciada de `IconProfile` (`_profile_active_white.svg`
 * en elcorteingles.es): las mismas formas con el fondo relleno.
 */
export const IconProfileActive = (p: IconProps) => (
  <SvgIcon {...p} viewBox="0 0 25.05 25.002">
    <g
      transform="translate(-1100.475 -137.5)"
      fill="currentColor"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1}
    >
      <circle cx="5.551" cy="5.551" r="5.551" transform="translate(1107.21 138)" />
      <path
        d="M94.163,48.555l-1.529.224a16.628,16.628,0,0,1-5.117-.045l-1.089-.179a6.145,6.145,0,0,0-5.21,2.629L78.53,55.418c-.7,1.106.25,2.442,1.737,2.442h20.055c1.488,0,2.438-1.336,1.737-2.442l-2.689-4.234A6.14,6.14,0,0,0,94.163,48.555Z"
        transform="translate(1022.705 104.143)"
      />
    </g>
  </SvgIcon>
)

export const IconPerson = (p: IconProps) => (
  <SvgIcon {...p} viewBox="0 0 12.3747 20.6811">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.18716 0C4.06086 0 2.33716 1.7237 2.33716 3.85C2.33716 5.9763 4.06086 7.7 6.18716 7.7C8.31345 7.7 10.0372 5.9763 10.0372 3.85C10.0372 1.7237 8.31345 0 6.18716 0ZM3.53716 3.85C3.53716 2.38645 4.7236 1.2 6.18716 1.2C7.65071 1.2 8.83716 2.38645 8.83716 3.85C8.83716 5.31355 7.65071 6.5 6.18716 6.5C4.7236 6.5 3.53716 5.31355 3.53716 3.85Z"
      fill="currentColor"
    />
    <path
      d="M12.3747 9H0L1.59287 20.6811H2.80088L1.37474 10.2H11L9.58123 20.6811H10.7819L12.3747 9Z"
      fill="currentColor"
    />
  </SvgIcon>
)

export const IconArrowDown = (p: IconProps) => (
  <SvgIcon {...p} viewBox="0 0 13.8485 18.3485">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.32426 16.0515V0H7.52426V16.0515L13 10.5757L13.8485 11.4243L6.92426 18.3485L0 11.4243L0.848528 10.5757L6.32426 16.0515Z"
      fill="currentColor"
    />
  </SvgIcon>
)

// ─── Estados / feedback ───────────────────────────────────────────────────────

export const IconCheckCircle = (p: IconProps) => (
  <SvgIcon {...p} viewBox="0 0 21.2 21.2">
    <path
      d="M9.10005 14.4485L15.5243 8.02419L14.6758 7.17566L9.10005 12.7514L6.52431 10.1757L5.67578 11.0242L9.10005 14.4485Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.6 0C4.74578 0 0 4.74578 0 10.6C0 16.4542 4.74578 21.2 10.6 21.2C16.4542 21.2 21.2 16.4542 21.2 10.6C21.2 4.74578 16.4542 0 10.6 0ZM1.2 10.6C1.2 5.40852 5.40852 1.2 10.6 1.2C15.7915 1.2 20 5.40852 20 10.6C20 15.7915 15.7915 20 10.6 20C5.40852 20 1.2 15.7915 1.2 10.6Z"
      fill="currentColor"
    />
  </SvgIcon>
)

export const IconCloseCircle = (p: IconProps) => (
  <SvgIcon {...p} viewBox="0 0 21.2 21.2">
    <path
      d="M6.17578 7.02431L9.75152 10.6L6.17578 14.1758L7.02431 15.0243L10.6 11.4486L14.1758 15.0243L15.0243 14.1758L11.4486 10.6L15.0243 7.02431L14.1758 6.17578L10.6 9.75152L7.02431 6.17578L6.17578 7.02431Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.6 0C4.74578 0 0 4.74578 0 10.6C0 16.4542 4.74578 21.2 10.6 21.2C16.4542 21.2 21.2 16.4542 21.2 10.6C21.2 4.74578 16.4542 0 10.6 0ZM1.2 10.6C1.2 5.40852 5.40852 1.2 10.6 1.2C15.7915 1.2 20 5.40852 20 10.6C20 15.7915 15.7915 20 10.6 20C5.40852 20 1.2 15.7915 1.2 10.6Z"
      fill="currentColor"
    />
  </SvgIcon>
)

export const IconInfoCircle = (p: IconProps) => (
  <SvgIcon {...p} viewBox="0 0 21.2 21.2">
    <path
      d="M10.6001 5.6001C11.0143 5.6001 11.3501 5.93588 11.3501 6.3501C11.3501 6.76431 11.0143 7.1001 10.6001 7.1001C10.1859 7.1001 9.8501 6.76431 9.8501 6.3501C9.8501 5.93588 10.1859 5.6001 10.6001 5.6001Z"
      fill="currentColor"
    />
    <path d="M11.2 9.6001V15.6001H10V9.6001H11.2Z" fill="currentColor" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.6 0C4.74578 0 0 4.74578 0 10.6C0 16.4542 4.74578 21.2 10.6 21.2C16.4542 21.2 21.2 16.4542 21.2 10.6C21.2 4.74578 16.4542 0 10.6 0ZM1.2 10.6C1.2 5.40852 5.40852 1.2 10.6 1.2C15.7915 1.2 20 5.40852 20 10.6C20 15.7915 15.7915 20 10.6 20C5.40852 20 1.2 15.7915 1.2 10.6Z"
      fill="currentColor"
    />
  </SvgIcon>
)

export const IconWarning = (p: IconProps) => (
  <SvgIcon {...p} viewBox="0 0 22.4301 19.425">
    <path d="M11.8191 6.3501V12.3501H10.6191V6.3501H11.8191Z" fill="currentColor" />
    <path
      d="M11.9692 15.1001C11.9692 14.6859 11.6335 14.3501 11.2192 14.3501C10.805 14.3501 10.4692 14.6859 10.4692 15.1001C10.4692 15.5143 10.805 15.8501 11.2192 15.8501C11.6335 15.8501 11.9692 15.5143 11.9692 15.1001Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.215 0L22.4301 19.425H0L11.215 0ZM2.07846 18.225H20.3516L11.215 2.4L2.07846 18.225Z"
      fill="currentColor"
    />
  </SvgIcon>
)

export const IconNotification = (p: IconProps) => (
  <SvgIcon {...p} viewBox="0 0 18.988 21">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.7845 2.12044C7.7587 2.00094 7.74512 1.87698 7.74512 1.75C7.74512 0.783502 8.52862 0 9.49512 0C10.4616 0 11.2451 0.783502 11.2451 1.75C11.2451 1.87696 11.2315 2.0009 11.2058 2.12038C12.5447 2.47422 13.746 3.24206 14.7396 4.33741C16.589 6.37623 16.8073 8.66182 16.8719 10.8237C16.8795 11.0787 16.8851 11.3312 16.8907 11.5812C16.9335 13.492 16.9735 15.2624 17.8579 16.9465C18.0035 17.2244 18.1706 17.543 18.3013 17.7922L18.988 19.0999H11.9221C11.8137 19.5383 11.5876 19.9431 11.2629 20.2678C10.794 20.7366 10.1582 21 9.49512 21C8.83208 21 8.19619 20.7366 7.72735 20.2678C7.40268 19.9431 7.17654 19.5383 7.06815 19.0999H0L0.690652 17.791C0.821908 17.5419 0.989481 17.2233 1.13459 16.9463C2.01765 15.2622 2.05708 13.4933 2.09965 11.5833C2.10524 11.3325 2.11088 11.0792 2.1185 10.8234C2.18287 8.66153 2.40135 6.37625 4.2508 4.33741C5.24436 3.24212 6.44565 2.4743 7.7845 2.12044ZM8.74512 1.75C8.74512 1.33579 9.0809 1 9.49512 1C9.90933 1 10.2451 1.33579 10.2451 1.75C10.2451 1.8153 10.2369 1.87846 10.2213 1.93861C9.98268 1.91295 9.74054 1.8999 9.49524 1.8999C9.24986 1.8999 9.00763 1.91296 8.76892 1.93863C8.75338 1.87848 8.74512 1.81531 8.74512 1.75ZM9.49524 3.0999C7.84429 3.0999 6.3416 3.81857 5.13961 5.14366C3.59814 6.84297 3.381 8.7422 3.31797 10.8591C3.31072 11.1024 3.30571 11.3497 3.30062 11.6001C3.26235 13.4854 3.22039 15.5526 2.19734 17.5035C2.13077 17.6306 2.05958 17.7663 1.98935 17.8999H17.0028L16.7949 17.5033C15.7705 15.5522 15.7283 13.4845 15.6898 11.5988C15.6847 11.349 15.6796 11.1022 15.6724 10.8595C15.6092 8.74236 15.3922 6.8429 13.8508 5.14366C12.6488 3.81857 11.1462 3.0999 9.49524 3.0999ZM8.43446 19.5607C8.30056 19.4268 8.19459 19.2702 8.1203 19.0999H10.8699C10.7956 19.2702 10.6897 19.4268 10.5558 19.5607C10.2745 19.842 9.89294 20 9.49512 20C9.09729 20 8.71576 19.842 8.43446 19.5607Z"
      fill="currentColor"
    />
  </SvgIcon>
)

// ─── Acciones ─────────────────────────────────────────────────────────────────

export const IconSettings = (p: IconProps) => (
  <SvgIcon {...p} viewBox="0 0 21.3801 21.3793">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.6898 6.33936C8.28741 6.33936 6.33984 8.28692 6.33984 10.6894C6.33984 13.0918 8.28741 15.0394 10.6898 15.0394C13.0923 15.0394 15.0398 13.0918 15.0398 10.6894C15.0398 8.28692 13.0923 6.33936 10.6898 6.33936ZM7.53984 10.6894C7.53984 8.94966 8.95015 7.53936 10.6898 7.53936C12.4295 7.53936 13.8398 8.94966 13.8398 10.6894C13.8398 12.4291 12.4295 13.8394 10.6898 13.8394C8.95015 13.8394 7.53984 12.4291 7.53984 10.6894Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.1367 1.85728L7.81191 0L5.16517 1.08969L4.83307 4.04483L4.05446 4.82328L1.09759 5.15533L0.00109172 7.80606L1.85759 10.1304V11.2323L0 13.5566L1.09873 16.2064L4.05676 16.5528L4.83529 17.3312L5.16739 20.2875L7.81858 21.3783L10.1434 19.5221H11.2456L13.5703 21.3793L16.2204 20.2809L16.5525 17.3257L17.3312 16.5472L20.288 16.2152L21.379 13.5645L19.5225 11.2401V10.1382L21.3801 7.81385L20.2814 5.16422L17.3256 4.83217L16.547 4.05371L16.2149 1.09742L13.5637 0.0011363L11.2389 1.85728H10.1367ZM5.97864 4.59637L6.27839 1.92909L7.61515 1.37873L9.71623 3.05728H11.6592L13.7592 1.38055L15.1015 1.93557L15.4014 4.60524L16.7742 5.97778L19.444 6.2777L20 7.61854L18.3225 9.71755V11.6605L20.0003 13.7612L19.4485 15.1019L16.7798 15.4016L15.407 16.7741L15.107 19.4434L13.7656 19.9994L11.666 18.3221H9.7231L7.62189 19.9997L6.28062 19.4479L5.98088 16.7797L4.6104 15.4095L1.93756 15.0964L1.38006 13.752L3.05759 11.6529V9.70998L1.38063 7.61043L1.93563 6.26876L4.60583 5.96891L5.97864 4.59637Z"
      fill="currentColor"
    />
  </SvgIcon>
)

export const IconDelete = (p: IconProps) => (
  <SvgIcon {...p} viewBox="0 0 16.2705 21.2">
    <path d="M4.53516 7.46667V17.6H5.73516V7.46667H4.53516Z" fill="currentColor" />
    <path d="M7.53516 7.46667V17.6H8.73516V7.46667H7.53516Z" fill="currentColor" />
    <path d="M10.5352 7.46667V17.6H11.7352V7.46667H10.5352Z" fill="currentColor" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.7352 0H3.53516V2.5H0L1.06857 21.2H15.202L16.2705 2.5H12.7352V0ZM11.5352 2.5V1.2H4.73516V2.5H11.5352ZM2.20196 20L1.27053 3.7H15L14.0686 20H2.20196Z"
      fill="currentColor"
    />
  </SvgIcon>
)

export const IconEdit = (p: IconProps) => (
  <SvgIcon {...p} viewBox="0 0 21 21">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21 3.6L17.4 0L1.25455 16.1455L0 21L4.85455 19.7455L21 3.6ZM1.67134 19.3287L2.33449 16.7626L14.8743 4.22279L16.7772 6.12574L4.23743 18.6655L1.67134 19.3287ZM17.6257 5.27721L19.3029 3.6L17.4 1.69706L15.7228 3.37426L17.6257 5.27721Z"
      fill="currentColor"
    />
  </SvgIcon>
)

// ─── Compartir / visibilidad ──────────────────────────────────────────────────

export const IconShareAndroid = (p: IconProps) => (
  <SvgIcon {...p} viewBox="0 0 17.3001 21.5999">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.7001 0C11.7119 0 10.1001 1.61177 10.1001 3.6C10.1001 4.05857 10.1858 4.49712 10.3422 4.90049L5.78835 8.04105C5.18189 7.57612 4.42321 7.2998 3.6 7.2998C1.61177 7.2998 0 8.91158 0 10.8998C0 12.888 1.61177 14.4998 3.6 14.4998C4.4322 14.4998 5.19844 14.2174 5.80815 13.7433L10.3646 16.6429C10.1941 17.0617 10.1001 17.5198 10.1001 17.9999C10.1001 19.9881 11.7119 21.5999 13.7001 21.5999C15.6883 21.5999 17.3001 19.9881 17.3001 17.9999C17.3001 16.0117 15.6883 14.3999 13.7001 14.3999C12.623 14.3999 11.6563 14.873 10.9966 15.6226L6.63033 12.8441C6.99086 12.2833 7.2 11.616 7.2 10.8998C7.2 10.1726 6.98436 9.49571 6.61355 8.92965L10.9584 5.93319C11.6187 6.70836 12.602 7.2 13.7001 7.2C15.6883 7.2 17.3001 5.58822 17.3001 3.6C17.3001 1.61177 15.6883 0 13.7001 0ZM11.3001 3.6C11.3001 2.27452 12.3746 1.2 13.7001 1.2C15.0256 1.2 16.1001 2.27452 16.1001 3.6C16.1001 4.92548 15.0256 6 13.7001 6C12.3746 6 11.3001 4.92548 11.3001 3.6ZM3.6 8.4998C2.27452 8.4998 1.2 9.57432 1.2 10.8998C1.2 12.2253 2.27452 13.2998 3.6 13.2998C4.92548 13.2998 6 12.2253 6 10.8998C6 9.57432 4.92548 8.4998 3.6 8.4998ZM13.7001 15.5999C12.3746 15.5999 11.3001 16.6744 11.3001 17.9999C11.3001 19.3254 12.3746 20.3999 13.7001 20.3999C15.0256 20.3999 16.1001 19.3254 16.1001 17.9999C16.1001 16.6744 15.0256 15.5999 13.7001 15.5999Z"
      fill="currentColor"
    />
  </SvgIcon>
)

export const IconShareIos = (p: IconProps) => (
  <SvgIcon {...p} viewBox="0 0 16.4 20.9485">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.2 0L11.6243 3.42426L10.7757 4.27279L8.8 2.29706V13.3485H7.6V2.29706L5.62426 4.27279L4.77574 3.42426L8.2 0ZM0 5.79853H3.7V6.99853H1.2V19.7485H15.2V6.99853H12.7V5.79853H16.4V20.9485H0V5.79853Z"
      fill="currentColor"
    />
  </SvgIcon>
)

export const IconVisibility = (p: IconProps) => (
  <SvgIcon {...p} viewBox="0 0 22.3132 14.7">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.1564 3C8.75396 3 6.8064 4.94756 6.8064 7.35C6.8064 9.75244 8.75396 11.7 11.1564 11.7C13.5588 11.7 15.5064 9.75244 15.5064 7.35C15.5064 4.94756 13.5588 3 11.1564 3ZM8.0064 7.35C8.0064 5.6103 9.4167 4.2 11.1564 4.2C12.8961 4.2 14.3064 5.6103 14.3064 7.35C14.3064 9.0897 12.8961 10.5 11.1564 10.5C9.4167 10.5 8.0064 9.0897 8.0064 7.35Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.1566 0C7.20704 0 4.43762 1.78294 2.66983 3.55074C1.78766 4.4329 1.15135 5.31403 0.734788 5.97562C0.526214 6.30689 0.371875 6.58448 0.268646 6.78156C0.21701 6.88014 0.178093 6.9587 0.151512 7.01391C0.138219 7.04151 0.128005 7.06329 0.120821 7.07883L0.11231 7.09741L0.109746 7.10309L0.108885 7.10501L0 7.35L0.108885 7.59499L0.109746 7.59691L0.11231 7.60259L0.120821 7.62117C0.128005 7.63671 0.138219 7.65849 0.151512 7.68609C0.178093 7.7413 0.21701 7.81986 0.268646 7.91844C0.371875 8.11552 0.526214 8.39311 0.734788 8.72438C1.15135 9.38597 1.78766 10.2671 2.66983 11.1493C4.43762 12.9171 7.20704 14.7 11.1566 14.7C15.1061 14.7 17.8756 12.9171 19.6434 11.1493C20.5255 10.2671 21.1618 9.38597 21.5784 8.72438C21.787 8.39311 21.9413 8.11552 22.0445 7.91844C22.0962 7.81986 22.1351 7.7413 22.1617 7.68609C22.175 7.65849 22.1852 7.63671 22.1924 7.62117L22.2009 7.60259L22.2034 7.59691L22.2043 7.59499L22.3132 7.35L22.2043 7.10501L22.2034 7.10309L22.2009 7.09741L22.1924 7.07883C22.1852 7.06329 22.175 7.04151 22.1617 7.01391C22.1351 6.9587 22.0962 6.88014 22.0445 6.78156C21.9413 6.58448 21.787 6.30689 21.5784 5.97562C21.1618 5.31403 20.5255 4.4329 19.6434 3.55074C17.8756 1.78294 15.1061 0 11.1566 0ZM1.75027 8.085C1.5604 7.78345 1.42177 7.5337 1.33164 7.36163L1.32556 7.35L1.33164 7.33837C1.42177 7.1663 1.5604 6.91655 1.75027 6.615C2.13058 6.01097 2.71302 5.2046 3.51835 4.39926C5.12556 2.79206 7.60614 1.2 11.1566 1.2C14.707 1.2 17.1876 2.79206 18.7948 4.39926C19.6002 5.2046 20.1826 6.01097 20.5629 6.615C20.7528 6.91655 20.8914 7.1663 20.9815 7.33837L20.9876 7.35L20.9815 7.36163C20.8914 7.5337 20.7528 7.78345 20.5629 8.085C20.1826 8.68903 19.6002 9.4954 18.7948 10.3007C17.1876 11.9079 14.707 13.5 11.1566 13.5C7.60614 13.5 5.12556 11.9079 3.51835 10.3007C2.71302 9.4954 2.13058 8.68903 1.75027 8.085Z"
      fill="currentColor"
    />
  </SvgIcon>
)

export const IconVisibilityOff = (p: IconProps) => (
  <SvgIcon {...p} viewBox="0 0 22.3132 18.1951">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.69677 0L19.504 17.3879L18.616 18.1951L16.0761 15.4012C14.6985 16.0311 13.0654 16.4476 11.1566 16.4476C7.20704 16.4476 4.43762 14.6646 2.66983 12.8968C1.78766 12.0147 1.15135 11.1335 0.734788 10.4719C0.526214 10.1407 0.371875 9.86308 0.268646 9.666C0.21701 9.56742 0.178093 9.48886 0.151512 9.43365C0.138219 9.40605 0.128005 9.38427 0.120821 9.36873L0.11231 9.35015L0.109746 9.34447L0.108885 9.34255L0 9.09756L0.108885 8.8533L0.109746 8.85065L0.11231 8.84496L0.120821 8.82639C0.128005 8.81085 0.138219 8.78907 0.151512 8.76146C0.178093 8.70626 0.21701 8.62769 0.268646 8.52912C0.371875 8.33204 0.526214 8.05445 0.734788 7.72318C1.15135 7.06159 1.78766 6.18046 2.66983 5.29829C3.34376 4.62436 4.16326 3.94823 5.13822 3.36952L2.80884 0.807207L3.69677 0ZM5.96404 4.27793L7.8142 6.31311C7.18497 7.06755 6.8064 8.03834 6.8064 9.09756C6.8064 11.5 8.75396 13.4476 11.1564 13.4476C12.067 13.4476 12.9123 13.1678 13.6109 12.6894L15.2236 14.4634C14.0622 14.942 12.7121 15.2476 11.1566 15.2476C7.60614 15.2476 5.12556 13.6555 3.51835 12.0483C2.71302 11.243 2.13058 10.4366 1.75027 9.83256C1.5604 9.53101 1.42177 9.28126 1.33164 9.10919L1.32556 9.09756L1.33164 9.08592C1.42177 8.91386 1.5604 8.66411 1.75027 8.36256C2.13058 7.75853 2.71302 6.95216 3.51835 6.14682C4.18068 5.4845 4.99132 4.82475 5.96404 4.27793ZM11.1564 12.2476C11.7557 12.2476 12.3159 12.0802 12.7929 11.7896L8.63218 7.21288C8.23915 7.73843 8.0064 8.39081 8.0064 9.09756C8.0064 10.8373 9.4167 12.2476 11.1564 12.2476Z"
      fill="currentColor"
    />
    <path
      d="M0 9.09756L0.108885 9.34255L0.656591 9.09756L0.108885 8.8533L0 9.09756Z"
      fill="currentColor"
    />
    <path
      d="M14.2274 9.80159C14.2791 9.57523 14.3064 9.33958 14.3064 9.09756C14.3064 7.35786 12.8961 5.94756 11.1564 5.94756C11.0179 5.94756 10.8814 5.9565 10.7476 5.97384L9.8223 4.95596C10.2427 4.82064 10.691 4.74756 11.1564 4.74756C13.5588 4.74756 15.5064 6.69512 15.5064 9.09756C15.5064 9.70909 15.3802 10.2912 15.1524 10.8191L14.2274 9.80159Z"
      fill="currentColor"
    />
    <path
      d="M18.7948 12.0483C18.3802 12.4629 17.9075 12.8765 17.3733 13.262L18.1849 14.1548C18.7312 13.7515 19.2165 13.3237 19.6434 12.8968C20.5255 12.0147 21.1618 11.1335 21.5784 10.4719C21.787 10.1407 21.9413 9.86308 22.0445 9.666C22.0962 9.56742 22.1351 9.48886 22.1617 9.43365C22.175 9.40605 22.1852 9.38427 22.1924 9.36873L22.2009 9.35015L22.2034 9.34447L22.2043 9.34255L22.3132 9.09756L22.2043 8.85257L22.2034 8.85065L22.2009 8.84496L22.1924 8.82639C22.1852 8.81085 22.175 8.78907 22.1617 8.76146C22.1351 8.70626 22.0962 8.62769 22.0445 8.52912C21.9413 8.33204 21.787 8.05445 21.5784 7.72318C21.1618 7.06159 20.5255 6.18046 19.6434 5.29829C17.8756 3.5305 15.1061 1.74756 11.1566 1.74756C9.77281 1.74756 8.5339 1.96642 7.43217 2.32682L8.32789 3.3121C9.18368 3.08197 10.125 2.94756 11.1566 2.94756C14.707 2.94756 17.1876 4.53962 18.7948 6.14682C19.6002 6.95216 20.1826 7.75853 20.5629 8.36256C20.7528 8.66411 20.8914 8.91386 20.9815 9.08592L20.9876 9.09756L20.9815 9.10919C20.8914 9.28126 20.7528 9.53101 20.5629 9.83256C20.1826 10.4366 19.6002 11.243 18.7948 12.0483Z"
      fill="currentColor"
    />
  </SvgIcon>
)

// ─── Comercio / contenido ─────────────────────────────────────────────────────

export const IconShoppingBag = (p: IconProps) => (
  <SvgIcon {...p} viewBox="0 0 13.2712 20.7">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.7354 0H3.5354V3.5H0.992308L0 20.7H13.2712L12.2789 3.5H9.7354V0ZM8.5354 4.7V6.6H9.7354V4.7H11.1462L12 19.5H1.27123L2.12507 4.7H3.5354V6.6H4.7354V4.7H8.5354ZM8.5354 3.5V1.2H4.7354V3.5H8.5354Z"
      fill="currentColor"
    />
  </SvgIcon>
)

export const IconShieldCheck = (p: IconProps) => (
  <SvgIcon {...p} viewBox="0 0 17.2077 21.4084">
    <path
      d="M7.404 13.2245L13.3283 7.30019L12.4797 6.45166L7.404 11.5274L5.32826 9.45166L4.47974 10.3002L7.404 13.2245Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.2077 4.45861L8.60385 0L0 4.45862L0.00392544 4.82783C0.0712743 11.1624 2.10707 16.856 8.25961 21.1672L8.60392 21.4084L8.94823 21.1672C15.1007 16.856 17.1381 11.166 17.2039 4.82772L17.2077 4.45861ZM8.60392 19.9383C3.21789 16.0122 1.34471 10.9469 1.2101 5.18309L8.60385 1.35156L15.9978 5.18318C15.8646 10.9499 13.9903 16.0121 8.60392 19.9383Z"
      fill="currentColor"
    />
  </SvgIcon>
)

export const IconClockExpress = (p: IconProps) => (
  <SvgIcon {...p} viewBox="0 0 22.0001 20">
    <path
      d="M12.0001 18.8C16.8602 18.8 20.8001 14.8601 20.8001 10C20.8001 5.13989 16.8602 1.2 12.0001 1.2C8.99717 1.2 6.34557 2.70409 4.75755 5H3.33789C5.06694 2.01099 8.29866 0 12.0001 0C17.5229 0 22.0001 4.47715 22.0001 10C22.0001 15.5228 17.5229 20 12.0001 20C8.29866 20 5.06694 17.989 3.33789 15H4.75755C6.34557 17.2959 8.99717 18.8 12.0001 18.8Z"
      fill="currentColor"
    />
    <path
      d="M11.3999 3.5H12.5999V9.64696L16.7913 11.9755L16.2085 13.0245L11.3999 10.353V3.5Z"
      fill="currentColor"
    />
    <path d="M2.5 6.90002H8.5V8.10002H2.5V6.90002Z" fill="currentColor" />
    <path d="M0 9.40002H5.5V10.6H0V9.40002Z" fill="currentColor" />
    <path d="M1.5 11.9H7.5V13.1H1.5V11.9Z" fill="currentColor" />
  </SvgIcon>
)

// Reloj/alarma — sustituye al bloque de fecha en `ProductosTabla` cuando
// `date_not_visible` trae texto (fecha "próximamente" sin día concreto que
// mostrar). Trazado tomado del asset exportado por Figma (nodo 5741:38074,
// `ProductosTablaDsk`/estado "Estado6"), distinto de `IconClockExpress` (ese
// lleva líneas de movimiento — reloj "exprés" de otro contexto, no encaja
// aquí).
export const IconClockPending = (p: IconProps) => (
  <SvgIcon {...p} viewBox="0 0 48 48">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.975 42.5C14.7917 41.5667 12.8917 40.2917 11.275 38.675C9.65833 37.0583 8.375 35.1583 7.425 32.975C6.475 30.7917 6 28.4545 6 25.9635C6 23.4722 6.475 21.1388 7.425 18.9635C8.375 16.7878 9.65833 14.8833 11.275 13.25C12.8917 11.6167 14.7917 10.3333 16.975 9.4C19.1583 8.46667 21.4833 8 23.95 8C26.4167 8 28.7417 8.46667 30.925 9.4C33.1083 10.3333 35.0167 11.6167 36.65 13.25C38.2833 14.8833 39.5667 16.7878 40.5 18.9635C41.4333 21.1388 41.9 23.4722 41.9 25.9635C41.9 28.4545 41.4333 30.7917 40.5 32.975C39.5667 35.1583 38.2833 37.0583 36.65 38.675C35.0167 40.2917 33.1083 41.5667 30.925 42.5C28.7417 43.4333 26.4167 43.9 23.95 43.9C21.4833 43.9 19.1583 43.4333 16.975 42.5ZM30 34.1L32.1 32L25.6 25.5V16H22.6V26.7L30 34.1ZM10.7 4.65L12.8 6.75L4.6 14.65L2.5 12.55L10.7 4.65ZM37.2 4.65L45.4 12.55L43.3 14.65L35.1 6.75L37.2 4.65ZM23.952 40.9C28.1173 40.9 31.65 39.4493 34.55 36.548C37.45 33.6463 38.9 30.113 38.9 25.948C38.9 21.7827 37.4493 18.25 34.548 15.35C31.6463 12.45 28.113 11 23.948 11C19.7827 11 16.25 12.4507 13.35 15.352C10.45 18.2537 9 21.787 9 25.952C9 30.1173 10.4507 33.65 13.352 36.55C16.2537 39.45 19.787 40.9 23.952 40.9Z"
      fill="currentColor"
    />
  </SvgIcon>
)

export const IconNotebook = (p: IconProps) => (
  <SvgIcon {...p} viewBox="0 0 24 24">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4 2h16a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1Zm1 2v16h14V4H5Zm2 3h10v1.2H7V7Zm0 3.4h10v1.2H7v-1.2Zm0 3.4h7v1.2H7v-1.2Z"
      fill="currentColor"
    />
  </SvgIcon>
)

export const IconChatBubble = (p: IconProps) => (
  <SvgIcon {...p} viewBox="0 0 20 20">
    <g transform="translate(1.166, 2.416)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 0H17.6667V12.1842H13.5V15.7684L9.40307 12.1842H0V0ZM1 1V11.1842H9.77875L12.5 13.5649V11.1842H16.6667V1H1Z"
        fill="currentColor"
      />
    </g>
  </SvgIcon>
)

export const IconTag = (p: IconProps) => (
  <SvgIcon {...p} viewBox="0 0 21 21">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0 0H11L21 10L10.5 21L0 10.5V0ZM1.2 1.2V10L10.5 19.3L19.2 10L10.5 1.2H1.2ZM4.5 3.5C3.9 3.5 3.5 3.9 3.5 4.5C3.5 5.1 3.9 5.5 4.5 5.5C5.1 5.5 5.5 5.1 5.5 4.5C5.5 3.9 5.1 3.5 4.5 3.5ZM2.3 4.5C2.3 3.2 3.2 2.3 4.5 2.3C5.8 2.3 6.7 3.2 6.7 4.5C6.7 5.8 5.8 6.7 4.5 6.7C3.2 6.7 2.3 5.8 2.3 4.5Z"
      fill="currentColor"
    />
  </SvgIcon>
)

// ─── Ubicación ────────────────────────────────────────────────────────────────

export const IconLocationFilled = (p: IconProps) => (
  <SvgIcon {...p} viewBox="0 0 15.2 21.4659">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.22725 2.3151C3.6529 0.832256 5.58565 0 7.6 0C9.61435 0 11.5471 0.832256 12.9728 2.3151C14.3985 3.79802 15.2 5.80995 15.2 7.90842C15.2 10.9828 13.3024 14.3629 11.4174 16.9649C10.4733 18.2681 9.52942 19.3801 8.8216 20.1663C8.50407 20.519 8.23399 20.8062 8.03262 21.0157L7.6 21.4659L7.16738 21.0157C6.96601 20.8062 6.69593 20.519 6.3784 20.1663C5.67058 19.3801 4.72668 18.2681 3.78262 16.9649C1.8976 14.3629 0 10.9828 0 7.90842C0 5.80995 0.801507 3.79802 2.22725 2.3151ZM7.59995 5.2002C6.27447 5.2002 5.19995 6.27471 5.19995 7.6002C5.19995 8.92568 6.27447 10.0002 7.59995 10.0002C8.92544 10.0002 9.99995 8.92568 9.99995 7.6002C9.99995 6.27471 8.92544 5.2002 7.59995 5.2002Z"
      fill="currentColor"
    />
  </SvgIcon>
)

export const IconPin = (p: IconProps) => (
  <SvgIcon {...p} viewBox="0 0 15.2 21.4">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.6 3.98772C5.61177 3.98772 4 5.59454 4 7.57666C4 9.55878 5.61177 11.1656 7.6 11.1656C9.58822 11.1656 11.2 9.55878 11.2 7.57666C11.2 5.59454 9.58822 3.98772 7.6 3.98772ZM5.2 7.57666C5.2 6.25525 6.27452 5.18403 7.6 5.18403C8.92548 5.18403 10 6.25525 10 7.57666C10 8.89807 8.92548 9.96929 7.6 9.96929C6.27452 9.96929 5.2 8.89807 5.2 7.57666Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.6 0C5.58565 0 3.6529 0.8297 2.22725 2.30799C0.801507 3.78636 0 5.79211 0 7.88413C0 10.9491 1.8976 14.3187 3.78262 16.9128C4.72668 18.212 5.67058 19.3206 6.3784 20.1044C6.69593 20.456 6.96601 20.7423 7.16738 20.9512L7.6 21.4L8.03262 20.9512C8.23399 20.7423 8.50407 20.456 8.8216 20.1044C9.52942 19.3206 10.4733 18.212 11.4174 16.9128C13.3024 14.3187 15.2 10.9491 15.2 7.88413C15.2 5.79211 14.3985 3.78636 12.9728 2.30799C11.5471 0.8297 9.61435 0 7.6 0ZM3.09229 3.13712C4.29683 1.88811 5.91943 1.19631 7.6 1.19631C9.28057 1.19631 10.9032 1.88811 12.1077 3.13712C13.3139 4.38787 14 6.09458 14 7.88413C14 10.5386 12.3158 13.6373 10.4456 16.211C9.53275 17.4672 8.61749 18.5424 7.92978 19.304C7.81271 19.4336 7.70239 19.554 7.6 19.6644C7.49761 19.554 7.38729 19.4336 7.27022 19.304C6.58251 18.5424 5.66725 17.4672 4.75442 16.211C2.88424 13.6373 1.2 10.5386 1.2 7.88413C1.2 6.09458 1.88606 4.38787 3.09229 3.13712Z"
      fill="currentColor"
    />
  </SvgIcon>
)

export const IconAccessibility = (p: IconProps) => (
  <SvgIcon {...p} viewBox="0 0 29.333 29.333">
    <path
      d="M20.5868 9.20486C21.1606 9.04302 21.8112 9.40817 21.9642 10.0165C22.1172 10.625 21.7718 11.3152 21.1979 11.4774L16.4928 12.9778C16.2633 13.0589 16.1098 13.3026 16.1097 13.5865C16.148 14.3977 16.2241 16.1417 16.3771 16.7912C16.7597 18.6574 18.8645 23.7701 18.8645 23.7701C19.132 24.3785 18.9023 25.0676 18.3286 25.3516C18.1757 25.4326 18.023 25.4732 17.8702 25.4733C17.4494 25.4733 17.0661 25.2297 16.8748 24.824L14.6559 19.25L12.4753 24.7834C12.3222 25.2297 11.9007 25.4733 11.4798 25.4733C11.327 25.4733 11.1743 25.4325 11.0215 25.3516C10.4859 25.0676 10.218 24.3785 10.4856 23.7701C10.4856 23.7701 12.5892 18.6574 12.9718 16.7912C13.1248 16.1419 13.2021 14.3977 13.2403 13.5865C13.2785 13.3026 13.0867 13.0589 12.8572 12.9778L8.15093 11.4774C7.539 11.315 7.19459 10.6249 7.38585 9.97591C7.5771 9.36755 8.22764 9.08347 8.80143 9.24544C8.80143 9.24544 13.1255 10.7064 14.6559 10.7064C16.2247 10.7063 20.5868 9.20486 20.5868 9.20486Z"
      fill="currentColor"
    />
    <path
      d="M14.7311 4.58333C15.9142 4.58351 16.8733 5.60032 16.8736 6.85471C16.8736 8.10932 15.9143 9.1271 14.7311 9.12728C13.5478 9.12728 12.5887 8.10943 12.5887 6.85471C12.5889 5.60022 13.5479 4.58333 14.7311 4.58333Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.6667 0C22.7668 0 29.3333 6.56649 29.3333 14.6667C29.3333 22.7668 22.7668 29.3333 14.6667 29.3333C6.56649 29.3333 0 22.7668 0 14.6667C0 6.56649 6.56649 0 14.6667 0ZM14.6667 2.44444C7.91652 2.44444 2.44444 7.91652 2.44444 14.6667C2.44444 21.4168 7.91652 26.8889 14.6667 26.8889C21.4168 26.8889 26.8889 21.4168 26.8889 14.6667C26.8889 7.91652 21.4168 2.44444 14.6667 2.44444Z"
      fill="currentColor"
    />
  </SvgIcon>
)

// ─── Contacto ─────────────────────────────────────────────────────────────────
// Trazados oficiales del DS (Figma) — mismos iconos ya usados por la ficha de
// recinto del proyecto de referencia `eci-firefly-uikit` (módulo Recinto,
// specs/038-recinto-module): web, email, teléfono/fax.

export const IconGlobe = (p: IconProps) => (
  <SvgIcon {...p} viewBox="0 0 21.2 21.2">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.6 0C4.74578 0 0 4.74578 0 10.6C0 16.4542 4.74578 21.2 10.6 21.2C16.4542 21.2 21.2 16.4542 21.2 10.6C21.2 4.74578 16.4542 0 10.6 0ZM12.0905 1.31751C12.4059 1.71013 12.7605 2.20134 13.1145 2.7913C13.76 3.86714 14.4026 5.27064 14.8004 7H19.286C18.0561 4.0359 15.3532 1.8373 12.0905 1.31751ZM12.0855 3.4087C12.64 4.33288 13.1971 5.52948 13.5662 7H7.63382C8.00292 5.52948 8.55999 4.33288 9.1145 3.4087C9.59194 2.61296 10.0679 2.01868 10.421 1.62638C10.485 1.55527 10.5449 1.49084 10.6 1.4331C10.6551 1.49084 10.715 1.55527 10.779 1.62638C11.1321 2.01868 11.6081 2.61296 12.0855 3.4087ZM14 10.6C14 9.74185 13.9312 8.9419 13.8122 8.2H7.38781C7.26878 8.9419 7.2 9.74185 7.2 10.6C7.2 11.4581 7.26878 12.2581 7.38781 13H13.8122C13.9312 12.2581 14 11.4581 14 10.6ZM13.5662 14.2H7.63382C8.00292 15.6705 8.55999 16.8671 9.1145 17.7913C9.59194 18.587 10.0679 19.1813 10.421 19.5736C10.485 19.6447 10.5449 19.7092 10.6 19.7669C10.6551 19.7092 10.715 19.6447 10.779 19.5736C11.1321 19.1813 11.6081 18.587 12.0855 17.7913C12.64 16.8671 13.1971 15.6705 13.5662 14.2ZM6.17361 13C6.063 12.2518 6 11.4518 6 10.6C6 9.7482 6.063 8.94816 6.17361 8.2H1.6C1.56972 8.2 1.53997 8.19775 1.51089 8.19343C1.30805 8.96153 1.2 9.76815 1.2 10.6C1.2 11.4319 1.30805 12.2385 1.51089 13.0066C1.53997 13.0022 1.56972 13 1.6 13H6.17361ZM1.91402 14.2H6.39965C6.79737 15.9294 7.44 17.3329 8.0855 18.4087C8.43948 18.9987 8.79414 19.4899 9.1095 19.8825C5.84684 19.3627 3.14391 17.1641 1.91402 14.2ZM14.8004 14.2H19.286C18.0561 17.1641 15.3532 19.3627 12.0905 19.8825C12.4059 19.4899 12.7605 18.9987 13.1145 18.4087C13.76 17.3329 14.4026 15.9294 14.8004 14.2ZM19.6891 13.0066C19.66 13.0022 19.6303 13 19.6 13H15.0264C15.137 12.2518 15.2 11.4518 15.2 10.6C15.2 9.7482 15.137 8.94816 15.0264 8.2H19.6C19.6303 8.2 19.66 8.19775 19.6891 8.19343C19.8919 8.96153 20 9.76815 20 10.6C20 11.4319 19.8919 12.2385 19.6891 13.0066ZM8.0855 2.7913C7.44 3.86714 6.79737 5.27064 6.39965 7H1.91402C3.14391 4.0359 5.84684 1.8373 9.1095 1.31751C8.79414 1.71013 8.43948 2.20134 8.0855 2.7913Z"
      fill="currentColor"
    />
  </SvgIcon>
)

export const IconMail = (p: IconProps) => (
  <SvgIcon {...p} viewBox="0 0 22.2 16.2">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M22.2 0H0V16.2H22.2V0ZM1.2 1.95213V15H21V1.95224L11.1001 10.9093L1.2 1.95213ZM20.0428 1.2H2.1573L11.1001 9.29106L20.0428 1.2Z"
      fill="currentColor"
    />
  </SvgIcon>
)

/** Icono de teléfono — reutilizado también para el fax (mismo icono oficial
 * del DS para ambos contactos de la ficha de recinto). */
export const IconPhone = (p: IconProps) => (
  <SvgIcon {...p} viewBox="0 0 20.7 20.7">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0 0H6.77878L9.0216 6.71877L6.41126 8.80405C7.01841 10.245 8.59572 12.5515 11.8401 14.1228C12.2543 13.4478 12.5236 12.9519 12.6179 12.7634L13.1923 11.6163L20.7 13.8653V20.5876L19.2628 20.672C16.0642 20.8599 11.2887 20.1391 7.26654 17.3135C3.15784 14.427 0 9.45519 0 1.52675V0ZM1.2 1.2V1.52675C1.2 9.08948 4.18752 13.6839 7.95636 16.3316C11.7067 18.9662 16.1962 19.6501 19.1924 19.4741L19.5 19.456V14.7585L13.8139 13.0551L13.6909 13.3006C13.5545 13.5732 13.1634 14.2861 12.575 15.2112L12.2985 15.646L11.827 15.4384C7.60467 13.5794 5.71468 10.5337 5.12667 8.80126L4.99131 8.40248L7.61808 6.30409L5.91427 1.2H1.2Z"
      fill="currentColor"
    />
  </SvgIcon>
)

// ─── Marca ECI ────────────────────────────────────────────────────────────────

export const IconEciFilled = (p: IconProps) => (
  <SvgIcon {...p} viewBox="0 0 20 20">
    <g transform="translate(1.542, 5.174)">
      <path d="M17.3682 4.87273L0 0V9.64898L17.3682 4.87273Z" fill="#008539" />
    </g>
  </SvgIcon>
)

export const IconShopDuo = (p: IconProps) => (
  <SvgIcon {...p} viewBox="0 0 20 20">
    <g transform="translate(2.834, 1.124)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.73865 0L14.3333 2.43505V17.7096H0V8.94921L2.75862 8.07202V2.37806L9.73865 0ZM2.75862 9.12135L1 9.68056V16.7096H2.75862V9.12135ZM3.75862 16.7096H9.1954V1.24153L3.75862 3.09381V16.7096ZM10.1954 1.37382V16.7096H13.3333V3.03683L10.1954 1.37382Z"
        fill="currentColor"
      />
    </g>
    <g transform="translate(7.442, 5.136)">
      <path d="M0 2.57076L0.00253518 0L3.72505 0.730874L0 2.57076Z" fill="#008539" />
    </g>
  </SvgIcon>
)

export const IconEciPlusDuo = (p: IconProps) => (
  <SvgIcon {...p} viewBox="0 0 20 20">
    <g transform="translate(1.542, 5.174)">
      <path
        d="M4.83333 1.35602L0 0V9.64898L17.3682 4.87273L12.6668 3.55375V4.59236L13.6318 4.8631L1 8.33686V1.31917L4.83333 2.39463V1.35602Z"
        fill="#008539"
      />
    </g>
    <g transform="translate(7.458, 4.592)">
      <path
        d="M3.70913 1.95092V0H2.0295V1.95092H0V3.52551H2.0295V5.47643H3.70913V3.52551H5.73842V1.95092H3.70913Z"
        fill="currentColor"
      />
    </g>
  </SvgIcon>
)

export const IconCardEci = (p: IconProps) => (
  <SvgIcon {...p} viewBox="0 0 20 20">
    <g transform="translate(0.834, 3.75)">
      <path d="M10.5833 6.27083L3.08329 4.16667V8.33333L10.5833 6.27083Z" fill="#008539" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 12.5V0H18.3333V12.5H0ZM1 1H17.3333V11.5H1V1Z"
        fill="#008539"
      />
    </g>
  </SvgIcon>
)

// ─── Multimedia ───────────────────────────────────────────────────────────────

export const IconPlay = (p: IconProps) => (
  <SvgIcon {...p} viewBox="0 0 16 18">
    <path d="M0 0V18L16 9L0 0Z" fill="currentColor" />
  </SvgIcon>
)

export const IconPause = (p: IconProps) => (
  <SvgIcon {...p} viewBox="0 0 13 17">
    <path fillRule="evenodd" clipRule="evenodd" d="M0 0H5V17H0V0ZM8 0H13V17H8V0Z" fill="currentColor" />
  </SvgIcon>
)

export const IconSpeakerHigh = (p: IconProps) => (
  <SvgIcon {...p} viewBox="0 0 20.43 20.4536">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.2 0V20.4536L5.64414 14.5768H0L3.89814e-05 5.87678H5.64413L13.2 0ZM12 2.45357L6.05586 7.07678H1.20002L1.2 13.3768H6.05586L12 18V2.45357Z"
      fill="currentColor"
    />
    <path d="M16.93 7.37677V13.0768H15.73V7.37677H16.93Z" fill="currentColor" />
    <path d="M20.43 14.5768V5.87677H19.23V14.5768H20.43Z" fill="currentColor" />
  </SvgIcon>
)

export const IconSpeakerMuted = (p: IconProps) => (
  <SvgIcon {...p} viewBox="0 0 20.43 20.4536">
    <path d="M13.4318 0V10.3132L12.2318 8.98382V2.45353L8.76863 5.14709L7.96241 4.25391L13.4318 0Z" fill="currentColor" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18.9251 18.5171L3.11791 1.12921L2.22998 1.93642L5.81212 5.87677L0 5.87677V14.5768H5.6441L13.2 20.4536V14.0034L18.0372 19.3243L18.9251 18.5171ZM12.0002 12.6837L6.90303 7.07677L1.19998 7.07677V13.3768H6.05583L12 18V12.7018L12.0002 12.6837Z"
      fill="currentColor"
    />
    <path d="M20.43 5.87677V14.5768H19.23V5.87677H20.43Z" fill="currentColor" />
    <path d="M16.93 7.37677V13.0768H15.73V7.37677H16.93Z" fill="currentColor" />
  </SvgIcon>
)

// ─── Categorías (estilo lineal, trazo de 2px sobre viewBox 24×24) ─────────────

// Trazado fiel al set de iconos de confianza del proyecto de referencia
// `eci-firefly-uikit` (usado por su módulo `Tranquilidad`) — icono relleno
// (`fill`), no de trazo, a diferencia del resto del set de este fichero.
export const IconTicket = (p: IconProps) => (
  <SvgIcon {...p} viewBox="0 0 24 24">
    <path
      d="M2.7876 9.68203L17.2502 1.33203L22.8502 11.0315L21.3347 11.9065L20.7347 10.8673L21.211 10.5923L16.811 2.97126L4.42683 10.1213L4.70183 10.5976L3.6626 11.1976L2.7876 9.68203Z"
      fill="currentColor"
    />
    <path d="M11.7791 13.5556L16.1092 11.0556L16.6092 11.9216L12.2791 14.4216L11.7791 13.5556Z" fill="currentColor" />
    <path d="M7.24786 12.7074L6.38184 13.2074L6.88184 14.0734L7.74786 13.5734L7.24786 12.7074Z" fill="currentColor" />
    <path d="M8.24786 14.4394L7.38184 14.9394L7.88184 15.8054L8.74786 15.3054L8.24786 14.4394Z" fill="currentColor" />
    <path d="M17.1092 12.7875L12.7791 15.2875L13.2791 16.1535L17.6092 13.6535L17.1092 12.7875Z" fill="currentColor" />
    <path d="M8.38184 16.6713L9.24786 16.1713L9.74786 17.0373L8.88184 17.5373L8.38184 16.6713Z" fill="currentColor" />
    <path d="M10.2479 17.9037L9.38184 18.4037L9.88184 19.2697L10.7479 18.7697L10.2479 17.9037Z" fill="currentColor" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.78125 13.4389L16.2439 5.08887L21.8439 14.7884L7.38125 23.1384L1.78125 13.4389ZM3.42048 13.8781L7.82048 21.4991L20.2046 14.3491L15.8046 6.7281L3.42048 13.8781Z"
      fill="currentColor"
    />
  </SvgIcon>
)

export const IconStore = (p: IconProps) => (
  <SvgIcon {...p} viewBox="0 0 24 24">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.7485 9.5C14.7485 8.5335 15.532 7.75 16.4985 7.75C17.465 7.75 18.2485 8.5335 18.2485 9.5C18.2485 10.4665 17.465 11.25 16.4985 11.25C15.532 11.25 14.7485 10.4665 14.7485 9.5ZM16.4985 8.75C16.0843 8.75 15.7485 9.08579 15.7485 9.5C15.7485 9.91421 16.0843 10.25 16.4985 10.25C16.9127 10.25 17.2485 9.91421 17.2485 9.5C17.2485 9.08579 16.9127 8.75 16.4985 8.75Z"
      fill="currentColor"
    />
    <path d="M4.24854 7.5L11.4485 9.52L4.24854 11.5V7.5Z" fill="currentColor" />
    <path d="M9.49854 18H3.99854V17H9.49854V18Z" fill="currentColor" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M23.0985 3.25H0.898487L0.898438 20.75H23.0984L23.0985 3.25ZM2.09845 14.4L2.09849 4.45H21.8985L21.8985 14.4H18.6284L19.1084 12H13.8886L14.3686 14.4H2.09845ZM17.6086 14.4L17.8886 13H15.1084L15.3884 14.4H17.6086ZM2.09845 15.6L2.09844 19.55H21.8984L21.8985 15.6H2.09845Z"
      fill="currentColor"
    />
  </SvgIcon>
)

export const IconCard = (p: IconProps) => (
  <SvgIcon {...p} viewBox="0 0 24 24">
    <path d="M13.7 12.025L4.69995 9.5V14.5L13.7 12.025Z" fill="currentColor" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1 19.5V4.5H23V19.5H1ZM2.2 5.7H21.8V18.3H2.2V5.7Z"
      fill="currentColor"
    />
  </SvgIcon>
)

export const IconShield = (p: IconProps) => (
  <SvgIcon {...p} viewBox="0 0 18 22">
    <path
      d="M7.60867 13.59L13.6967 7.50199L12.8247 6.63001L7.60867 11.8461L5.47556 9.71294L4.60357 10.5849L7.60867 13.59Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.6834 4.58186L8.84169 0L0 4.58187L0.00403396 4.96129C0.0732445 11.471 2.16532 17.322 8.48793 21.7523L8.84176 22.0002L9.19559 21.7523C15.5181 17.322 17.6118 11.4746 17.6794 4.96117L17.6834 4.58186ZM8.84176 20.4895C3.30684 16.4548 1.38188 11.2495 1.24355 5.32636L8.84169 1.38892L16.44 5.32646C16.3031 11.2525 14.377 16.4547 8.84176 20.4895Z"
      fill="currentColor"
    />
  </SvgIcon>
)

export const IconDiamond = (p: IconProps) => (
  <SvgIcon {...p} viewBox="0 0 24 24">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.2 2.5h11.6l4.2 7.1L12 22 2 9.6 6.2 2.5Zm.68 1.2L3.9 8.7h4.06l1.2-4.99-2.28-.01Zm3.5 0-1.24 5.15h5.72L13.62 3.7h-3.24Zm4.46.01 1.2 4.99H20.1L17.12 3.7l-2.28.01ZM19.9 9.9h-3.86L13.1 18.6 19.9 9.9Zm-5.12 0H9.22L12 19.7l2.78-9.8ZM7.96 9.9H4.1L10.9 18.6 7.96 9.9Z"
      fill="currentColor"
    />
  </SvgIcon>
)

export const IconMusic = (p: IconProps) => (
  <SvgIcon {...p} viewBox="0 0 24 24">
    <path
      d="M9 18V5l11-2v13"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <circle
      cx="6"
      cy="18"
      r="3"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <circle
      cx="17"
      cy="16"
      r="3"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
)

export const IconMasks = (p: IconProps) => (
  <SvgIcon {...p} viewBox="0 0 24 24">
    <path
      d="M3 4h8v6a4 4 0 0 1-8 0V4Z"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13 8h8v6a4 4 0 0 1-8 0V8Z"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.5 7.5h.01M8.5 7.5h.01M15.5 11.5h.01M18.5 11.5h.01"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
)

export const IconMusicales = (p: IconProps) => (
  <SvgIcon {...p} viewBox="0 0 24 24">
    <circle
      cx="9"
      cy="7"
      r="3.2"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.5 20v-1a5.5 5.5 0 0 1 11 0v1"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17 14V7l4-1v6"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <circle
      cx="15.5"
      cy="14.5"
      r="1.6"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
)

export const IconParty = (p: IconProps) => (
  <SvgIcon {...p} viewBox="0 0 24 24">
    <path
      d="M3 21 9.5 7l7.5 7.5L3 21Z"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14 5.5c1-1 2.5-1 3 0M18 4c.6-1 2-1.4 3-.5M16.5 9.5c1.2-.4 2.4.2 2.8 1.4"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="m12.5 9 1 1M16 12.5l1 1"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
)

export const IconPalette = (p: IconProps) => (
  <SvgIcon {...p} viewBox="0 0 24 24">
    <path
      d="M12 3a9 9 0 1 0 0 18c1.4 0 2-1 2-2 0-1.2-1-1.6-1-2.6 0-.8.7-1.4 1.5-1.4H17a4 4 0 0 0 4-4c0-4.4-4-8-9-8Z"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <circle
      cx="7.5"
      cy="11"
      r="1"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <circle
      cx="11"
      cy="7.5"
      r="1"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <circle
      cx="15.5"
      cy="8.5"
      r="1"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
)

export const IconFamily = (p: IconProps) => (
  <SvgIcon {...p} viewBox="0 0 24 24">
    <circle
      cx="7"
      cy="6"
      r="2.4"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <circle
      cx="17"
      cy="6"
      r="2.4"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.5 21v-5a3.5 3.5 0 0 1 7 0v5M13.5 21v-5a3.5 3.5 0 0 1 7 0v5"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
)

export const IconSport = (p: IconProps) => (
  <SvgIcon {...p} viewBox="0 0 24 24">
    <circle
      cx="12"
      cy="12"
      r="9"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 3c0 4.5-2 7.5-2 9s2 4.5 2 9M3 12h18M5 6.5C7 8 9.5 9 12 9s5-1 7-2.5M5 17.5C7 16 9.5 15 12 15s5 1 7 2.5"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
)

export const IconExperience = (p: IconProps) => (
  <SvgIcon {...p} viewBox="0 0 24 24">
    <path
      d="M12 2l2.4 7.4H22l-6.2 4.5 2.4 7.4L12 17l-6.2 4.3 2.4-7.4L2 9.4h7.6z"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
)

export const IconOnline = (p: IconProps) => (
  <SvgIcon {...p} viewBox="0 0 24 24">
    <rect
      x="2"
      y="3"
      width="20"
      height="14"
      rx="2"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8 21h8M12 17v4"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
)

export const IconAgenda = (p: IconProps) => (
  <SvgIcon {...p} viewBox="0 0 24 24">
    <rect
      x="3"
      y="4"
      width="18"
      height="18"
      rx="1"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16 2v4M8 2v4M3 10h18"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
)

export const IconVenue = (p: IconProps) => (
  <SvgIcon {...p} viewBox="0 0 24 24">
    <path
      d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <polyline
      points="9 22 9 12 15 12 15 22"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
)

// Icono de promoción — mismo trazado (icon_tag DS) que el proyecto de
// referencia eci-firefly-uikit (`IconTag`), paridad visual solicitada para
// el badge de promo/descuento (specs/019-estados-compra-eventos).
export const IconPromo = (p: IconProps) => (
  <SvgIcon {...p} viewBox="0 0 24 24">
    <path
      d="M18.9426 4.96696L14.3754 1.5L12.6341 2.90993L13.5895 3.6835L14.399 3.02805L17.7894 5.6017L18.7213 19.2784H17.9251L18.0075 20.4865H20.0001L18.9426 4.96696Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.8501 8.75C8.8501 7.7835 9.6336 7 10.6001 7C11.5666 7 12.3501 7.7835 12.3501 8.75C12.3501 9.7165 11.5666 10.5 10.6001 10.5C9.6336 10.5 8.8501 9.7165 8.8501 8.75ZM10.6001 8C10.1859 8 9.8501 8.33579 9.8501 8.75C9.8501 9.16421 10.1859 9.5 10.6001 9.5C11.0143 9.5 11.3501 9.16421 11.3501 8.75C11.3501 8.33579 11.0143 8 10.6001 8Z"
      fill="currentColor"
    />
    <path d="M9.15541 19.25L11.2387 13L12.1281 13.2965L10.0448 19.5465L9.15541 19.25Z" fill="currentColor" />
    <path
      d="M8.93343 15.6485C9.39367 15.6485 9.76676 15.2754 9.76676 14.8151C9.76676 14.3549 9.39367 13.9818 8.93343 13.9818C8.47319 13.9818 8.1001 14.3549 8.1001 14.8151C8.1001 15.2754 8.47319 15.6485 8.93343 15.6485Z"
      fill="currentColor"
    />
    <path
      d="M13.1001 18.1485C13.1001 18.6087 12.727 18.9818 12.2668 18.9818C11.8065 18.9818 11.4334 18.6087 11.4334 18.1485C11.4334 17.6882 11.8065 17.3151 12.2668 17.3151C12.727 17.3151 13.1001 17.6882 13.1001 18.1485Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.6076 2.49718L16.1584 6.99176L17.2151 22.5H4L5.05671 6.99176L10.6076 2.49718ZM6.21147 7.60389L5.27879 21.2919H15.9363L15.0037 7.60389L10.6076 4.04433L6.21147 7.60389Z"
      fill="currentColor"
    />
  </SvgIcon>
)

export const IconBlog = (p: IconProps) => (
  <SvgIcon {...p} viewBox="0 0 24 24">
    <path
      d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <polyline
      points="14 2 14 8 20 8"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <line
      x1="16"
      y1="13"
      x2="8"
      y2="13"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <line
      x1="16"
      y1="17"
      x2="8"
      y2="17"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <polyline
      points="10 9 9 9 8 9"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
)

export const IconAlert = (p: IconProps) => (
  <SvgIcon {...p} viewBox="0 0 24 24">
    <path
      d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <line
      x1="12"
      y1="9"
      x2="12"
      y2="13"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <line
      x1="12"
      y1="17"
      x2="12.01"
      y2="17"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
)

// ─── Redes sociales ───────────────────────────────────────────────────────────

export const IconFacebook = (p: IconProps) => (
  <SvgIcon {...p} viewBox="0 0 24 24">
    <path
      d="M12 1.5C17.7988 1.5 22.4997 6.21807 22.5 12.0381C22.5 17.4262 18.4716 21.8698 13.2725 22.5V15.2588H16.1133L16.7021 12.0381H13.2725V10.8994C13.2725 9.19785 13.9379 8.54304 15.6592 8.54297C16.1936 8.54297 16.6242 8.55592 16.8721 8.58203V5.66309C16.4023 5.53245 15.255 5.40138 14.5898 5.40137C11.0813 5.40137 9.46401 7.0638 9.46387 10.6504V12.0381H7.29883V15.2588H9.46387V22.2666C4.89049 21.1276 1.5 16.9803 1.5 12.0381C1.50026 6.21807 6.20122 1.5 12 1.5Z"
      fill="currentColor"
    />
  </SvgIcon>
)

export const IconInstagram = (p: IconProps) => (
  <SvgIcon {...p} viewBox="0 0 20.9996 21.0005">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.4896 5.10859C13.4669 5.10288 15.886 7.51193 15.8919 10.4895C15.8976 13.4672 13.4872 15.886 10.5101 15.8918C7.5329 15.8975 5.11463 13.4887 5.10871 10.5109C5.10304 7.53355 7.51195 5.11447 10.4896 5.10859ZM11.1761 7.06562C10.4969 6.93192 9.79266 7.00257 9.15363 7.26875C8.51464 7.53493 7.9687 7.98541 7.58527 8.56172C7.20201 9.13796 6.99797 9.81497 6.99933 10.507C7.00019 10.9667 7.09216 11.4216 7.26886 11.8459C7.44554 12.2701 7.70403 12.6553 8.0296 12.9797C8.35519 13.304 8.74142 13.5615 9.16632 13.7365C9.59135 13.9116 10.0475 14.0012 10.5071 14.0002C11.1992 13.9987 11.8758 13.7921 12.4505 13.4064C13.0251 13.0208 13.4721 12.4731 13.7357 11.8332C13.9993 11.1932 14.0673 10.4894 13.931 9.81074C13.7946 9.1322 13.4603 8.50918 12.97 8.0207C12.4796 7.53223 11.8552 7.19936 11.1761 7.06562Z"
      fill="currentColor"
    />
    <path
      d="M16.0911 3.62617C16.3402 3.62568 16.5839 3.69919 16.7913 3.83711C16.9987 3.97512 17.1613 4.17159 17.2571 4.40156C17.353 4.63163 17.3776 4.88555 17.3294 5.13008C17.2812 5.37437 17.1623 5.59914 16.9866 5.77558C16.8109 5.952 16.5862 6.07216 16.3421 6.12129C16.0978 6.17035 15.844 6.14595 15.6136 6.05098C15.3832 5.95601 15.186 5.79507 15.0472 5.58808C14.9085 5.38121 14.8338 5.13794 14.8333 4.88887C14.8328 4.55476 14.9657 4.23394 15.2015 3.99726C15.4373 3.76068 15.7571 3.62684 16.0911 3.62617Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.4798 0.00117059C13.3312 -0.00428848 13.6913 0.0085356 14.8089 0.0568346C15.9264 0.105154 16.6896 0.281747 17.3577 0.540233C18.0492 0.806511 18.6358 1.16453 19.22 1.74726C19.8041 2.32993 20.1641 2.91451 20.4339 3.60469C20.6957 4.27223 20.8739 5.03293 20.9271 6.15254C20.9802 7.2719 20.9929 7.63008 20.9984 10.4807C21.0038 13.3312 20.9926 13.6891 20.9437 14.8098C20.8952 15.9265 20.719 16.6908 20.4603 17.3586C20.1934 18.0501 19.835 18.6364 19.2532 19.2209C18.6714 19.8054 18.0859 20.1647 17.3958 20.4348C16.7285 20.6956 15.9698 20.8748 14.8499 20.9279C13.73 20.9811 13.371 20.9938 10.5208 20.9992C7.67049 21.0047 7.31009 20.9934 6.19269 20.9445C5.07506 20.8956 4.31069 20.7192 3.64289 20.4611C2.95006 20.1936 2.36489 19.8363 1.78058 19.2541C1.19627 18.6719 0.836129 18.0868 0.566714 17.3967C0.304659 16.7296 0.126911 15.9666 0.0735503 14.8498C0.0193709 13.7297 0.00674492 13.3719 0.00128467 10.5207C-0.00417538 7.66931 0.00662167 7.30943 0.0559722 6.1916C0.105346 5.07398 0.279912 4.31015 0.538394 3.6418C0.805481 2.95063 1.16444 2.36555 1.7464 1.78144C2.32853 1.19722 2.91355 0.835611 3.60382 0.5666C4.27072 0.304548 5.03367 0.126165 6.1507 0.0734362C7.27064 0.018836 7.62818 0.0066306 10.4798 0.00117059ZM10.4827 1.8957C7.67985 1.90179 7.34788 1.91254 6.24054 1.96504C5.21759 2.01376 4.6623 2.18485 4.2923 2.3293C3.8024 2.5208 3.45267 2.74846 3.08625 3.11738C2.71979 3.48635 2.49204 3.83518 2.30304 4.32637C2.16089 4.69655 1.98933 5.25292 1.94562 6.27558C1.89711 7.38247 1.8868 7.71468 1.89289 10.5178C1.89898 13.321 1.91014 13.6535 1.96222 14.76C2.01009 15.7834 2.18266 16.3387 2.32648 16.7092C2.518 17.1987 2.74538 17.5496 3.11457 17.9152C3.48372 18.2808 3.83302 18.5094 4.32355 18.6984C4.69399 18.8408 5.24999 19.0104 6.27375 19.0549C7.38105 19.1028 7.71202 19.1147 10.5159 19.1086C13.3199 19.1025 13.6518 19.0913 14.7591 19.0393C15.7815 18.9905 16.3377 18.8183 16.7073 18.674C17.1973 18.4825 17.5468 18.2556 17.9134 17.8869C18.28 17.5182 18.5076 17.1682 18.6966 16.6779C18.8392 16.3071 19.0093 15.7512 19.054 14.7277C19.1025 13.6213 19.1118 13.2879 19.1068 10.4855C19.1017 7.683 19.0901 7.35058 19.0374 6.24336C18.9891 5.21939 18.8169 4.66409 18.6722 4.29512C18.4807 3.80424 18.253 3.45609 17.8841 3.08906C17.5151 2.72202 17.1659 2.49485 16.6751 2.30586C16.3053 2.16287 15.7485 1.99294 14.7259 1.94844C13.6183 1.89972 13.2855 1.88961 10.4827 1.8957Z"
      fill="currentColor"
    />
  </SvgIcon>
)

export const IconPinterest = (p: IconProps) => (
  <SvgIcon {...p} viewBox="0 0 21 21">
    <path
      d="M10.5 0C16.3018 9.92206e-08 21 4.7018 21 10.4922C21 16.2983 16.3018 21 10.5 21C9.41226 21 8.37193 20.8261 7.39453 20.5264C7.82021 19.8163 8.46668 18.6806 8.70312 17.7656C8.82928 17.2764 9.34863 15.2725 9.34863 15.2725C9.69548 15.9193 10.7054 16.4717 11.7617 16.4717C14.9146 16.4714 17.2002 13.5524 17.2002 9.93945C17.2 6.48438 14.3781 3.88086 10.7363 3.88086C6.21184 3.88093 3.8 6.92616 3.7998 10.2393C3.7998 11.7854 4.61921 13.6952 5.92773 14.3105C6.11692 14.4052 6.22712 14.3573 6.27441 14.168C6.30607 14.0255 6.47977 13.3167 6.55859 12.9854C6.57435 12.8749 6.55825 12.7959 6.47949 12.6855C6.03807 12.1649 5.69143 11.1864 5.69141 10.2871C5.69141 7.96791 7.45704 5.72775 10.4365 5.72754C13.0063 5.72754 14.8193 7.49433 14.8193 10.0029C14.8193 12.8429 13.3848 14.8154 11.5244 14.8154C10.4841 14.8152 9.71167 13.9631 9.96387 12.9219C10.2634 11.6754 10.8311 10.3183 10.8311 9.41895C10.831 8.61444 10.4053 7.93656 9.50684 7.93652C8.4663 7.93652 7.61523 9.02487 7.61523 10.4922C7.61525 11.4158 7.92584 12.044 7.93066 12.0537C7.93066 12.0537 6.88942 16.4558 6.7002 17.2764C6.49524 18.1915 6.57435 19.4538 6.66895 20.29C2.75904 18.7596 0 14.9571 0 10.5078C4.09733e-05 4.70169 4.69822 0 10.5 0Z"
      fill="currentColor"
    />
  </SvgIcon>
)

export const IconTiktok = (p: IconProps) => (
  <SvgIcon {...p} viewBox="0 0 17.9995 21.0001">
    <path
      d="M13.0737 0C13.0678 0 13.0307 0.345733 13.1206 0.879883H13.1157C13.2236 1.52345 13.5162 2.44254 14.2993 3.34863C14.6121 3.69084 14.9647 3.99405 15.3491 4.25098C15.4154 4.29454 15.483 4.33587 15.5512 4.37598L15.7583 4.49121C16.6699 4.95071 17.5606 5.09105 17.9995 5.04297V8.62305C17.9727 8.6219 16.738 8.56774 15.8188 8.32129C14.5238 7.97067 13.6928 7.43262 13.6928 7.43262C13.6836 7.42645 13.1168 7.04664 13.0737 7.02051V14.4199C13.0736 14.8312 12.9659 15.8601 12.643 16.7178C12.3602 17.4515 11.9553 18.1312 11.4467 18.7275C11.4262 18.7531 10.6332 19.7335 9.25339 20.3945C7.99256 20.9986 6.88181 20.9854 6.55027 20.999C6.52811 20.9999 4.62634 21.07 2.90964 19.8906L2.90085 19.8818V19.8906C2.31705 19.4789 1.79667 18.9821 1.35593 18.417C0.809439 17.712 0.473676 16.8761 0.38718 16.6309V16.6221C0.249584 16.2061 -0.0388475 15.1994 0.0043672 14.2275C0.0731924 12.5158 0.640748 11.4608 0.791477 11.1982C1.18729 10.4786 1.70423 9.83398 2.31882 9.29395C3.02028 8.69932 3.8365 8.25813 4.7153 7.99805C5.59374 7.73797 6.51647 7.6657 7.42429 7.78418L7.42038 11.4561C7.12134 11.3575 6.80823 11.3076 6.49363 11.3076C4.83189 11.3077 3.48494 12.6783 3.48484 14.3701C3.48484 16.062 4.83182 17.4325 6.49363 17.4326C7.01103 17.4333 7.51952 17.2976 7.96921 17.0391C8.40067 16.7909 8.76585 16.4393 9.03171 16.0156C9.29706 15.5918 9.4559 15.1084 9.49362 14.6084V14.6006C9.49569 14.5901 9.49558 14.5794 9.49558 14.5693C9.49696 14.5449 9.49851 14.5237 9.49851 14.501C9.50645 14.3183 9.50632 14.1335 9.50632 13.9463V0H13.0737Z"
      fill="currentColor"
    />
  </SvgIcon>
)

export const IconX = (p: IconProps) => (
  <SvgIcon {...p} viewBox="0 0 20 21">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.95508 0L11.1191 7.7207L17.584 0H19.3486L11.9023 8.8916L20 21H14.0449L8.5918 12.8467L1.76465 21H0L7.80859 11.6758L0 0H5.95508ZM2.40039 1.36426L14.875 19.6973H17.585L5.11035 1.36426H2.40039Z"
      fill="currentColor"
    />
  </SvgIcon>
)

export const IconYoutube = (p: IconProps) => (
  <SvgIcon {...p} viewBox="0 0 21 15">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.4922 2.02751e-09C10.4922 2.02751e-09 17.0734 -0.000471354 18.6992 0.453125C19.6196 0.703724 20.309 1.42388 20.5547 2.34668C20.9995 4.00457 21 7.49219 21 7.49219C21 7.52841 20.9971 10.9885 20.5547 12.6533C20.309 13.5605 19.6196 14.2968 18.6992 14.5469C17.0734 15.0005 10.4922 15 10.4922 15C10.4582 15 3.92241 14.9993 2.30078 14.5469C1.39578 14.2963 0.690232 13.5605 0.429688 12.6533C0.00252196 10.988 1.17354e-05 7.52841 0 7.49219C0 7.49219 0.000271529 4.0046 0.429688 2.34668C0.690232 1.42388 1.39578 0.703184 2.30078 0.453125C3.92241 0.000707865 10.4582 3.05978e-06 10.4922 2.02751e-09ZM8.40625 10.7139L13.8525 7.49219L8.40625 4.28516V10.7139Z"
      fill="currentColor"
    />
  </SvgIcon>
)

export const IconWhatsapp = (p: IconProps) => (
  <SvgIcon {...p} viewBox="0 0 21 21">
    <path
      d="M7.34273 5.60982C7.50268 5.6183 7.71883 5.5494 7.93093 6.05633C8.14908 6.57683 8.67112 7.85666 8.73633 7.98686C8.80145 8.1171 8.84501 8.26911 8.75777 8.44269C8.67066 8.61569 8.62758 8.72455 8.49676 8.87615C8.36597 9.02779 8.22159 9.21431 8.10431 9.33105C7.97401 9.46026 7.83826 9.6011 7.99059 9.86146C8.14296 10.1219 8.66726 10.9738 9.44385 11.6634C10.4419 12.5488 11.2838 12.8233 11.545 12.9535C11.8061 13.0836 11.9584 13.0618 12.1108 12.8882C12.2633 12.715 12.7647 12.1298 12.9386 11.8694C13.1126 11.609 13.2862 11.652 13.5258 11.7389C13.7657 11.8258 15.0493 12.4539 15.3109 12.5843C15.5719 12.7144 15.7463 12.781 15.8115 12.8892C15.8767 12.9974 15.8762 13.5189 15.6586 14.1262C15.4408 14.7332 14.3978 15.2873 13.8959 15.3622C13.4458 15.4291 12.8763 15.4567 12.2506 15.2587C11.8712 15.139 11.384 14.9794 10.761 14.7116C8.14177 13.5855 6.43021 10.9614 6.29776 10.7852C6.16692 10.6116 5.23042 9.37432 5.23042 8.09499C5.23043 6.8157 5.90525 6.18625 6.14489 5.92583C6.38452 5.66537 6.66768 5.6005 6.84215 5.6005C7.01653 5.6005 7.19037 5.60234 7.34273 5.60982Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.5438 0C13.1659 0.000935488 15.6372 0.953508 17.5621 2.69305L17.9406 3.05194C19.9148 5.01872 21.0009 7.63286 21 10.4133C20.998 16.1508 16.3064 20.8192 10.5438 20.8192H10.5392C8.78954 20.8186 7.0697 20.3825 5.5427 19.5533L0 21L1.48309 15.6074C0.568155 14.0297 0.0866216 12.239 0.0876243 10.4049C0.0897825 4.66767 4.78041 0.000155305 10.5438 0ZM10.5475 1.75715C5.75355 1.75721 1.85517 5.63736 1.85316 10.4059C1.85218 12.0398 2.31167 13.6319 3.18151 15.0089L3.38845 15.3361L2.51034 18.5279L5.79998 17.6693L6.11692 17.8567C7.45153 18.6446 8.98177 19.0615 10.541 19.062H10.5438C15.3339 19.062 19.2324 15.1814 19.2345 10.4124C19.2354 8.10185 18.3324 5.9281 16.6915 4.29359C15.0506 2.65874 12.8686 1.75815 10.5475 1.75715Z"
      fill="currentColor"
    />
  </SvgIcon>
)

// `IconGallery` — glifo genérico "marco de fotos con paisaje" (marco + sol +
// montañas), no un trazado exacto de Figma (sin acceso al archivo de diseño
// para este glifo concreto, a diferencia del resto de iconos de este
// fichero) — usado por el botón "Ver galería" del módulo CMS Multimedia
// (specs/039-multimedia-module). Sustituir por el trazado oficial del DS si
// o cuando esté disponible.
export const IconGallery = (p: IconProps) => (
  <SvgIcon {...p} viewBox="0 0 24 24">
    <rect
      x="2.75"
      y="4.75"
      width="18.5"
      height="14.5"
      rx="1.5"
      stroke="currentColor"
      strokeWidth="1.5"
    />
    <circle cx="8.25" cy="9.75" r="1.5" stroke="currentColor" strokeWidth="1.5" />
    <path
      d="M3.5 16.5L8.5 11.5L12.5 15.5L15.5 11L20.5 16"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
)

// ─── Datos destacados de la ficha de evento (PDP) ──────────────────────────────
// Iconos exclusivos de `PerformanceHighlights` — se corresponden 1:1 con los de
// `eci-firefly-uikit` (asset "duration"/"doors"/"organizer") o, en el caso del
// micrófono, con el set de contorno (stroke) ya usado por el DS.

export const IconMicrophone = (p: IconProps) => (
  <SvgIcon {...p} viewBox="0 0 24 24">
    <path
      d="M12 1a3 3 0 0 0-3 3v8a3 3 0 0 0 6 0V4a3 3 0 0 0-3-3z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19 10v2a7 7 0 0 1-14 0v-2"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <line x1="12" y1="19" x2="12" y2="23" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    <line x1="8" y1="23" x2="16" y2="23" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
  </SvgIcon>
)

export const IconDuration = (p: IconProps) => (
  <SvgIcon {...p} viewBox="0 0 25 25">
    <path
      d="M0 11.7617C0.0630005 11.2892 0.110251 10.8128 0.192939 10.3442C0.696943 7.4501 2.07508 5.03639 4.27222 3.09519C6.13861 1.4493 8.31607 0.449166 10.7849 0.118414C13.8798 -0.29109 16.7463 0.36254 19.3687 2.06355C20.7862 2.98494 21.9557 4.15832 22.8967 5.56008C22.9322 5.61127 22.9716 5.65852 23.0464 5.7609C23.0464 5.62308 23.0464 5.54433 23.0464 5.46952C23.0464 4.69776 23.0424 3.92207 23.0464 3.15031C23.0503 2.53212 23.4559 2.09505 24.0229 2.09899C24.5899 2.09899 24.9955 2.53606 24.9955 3.15425C24.9994 4.0717 25.0033 4.99308 24.9955 5.91052C24.9797 7.7021 23.6331 9.05267 21.8415 9.07236C20.8807 9.08417 19.92 9.0763 18.9632 9.07236C18.3489 9.06842 17.9158 8.65498 17.9236 8.08404C17.9315 7.52885 18.3607 7.12328 18.9632 7.11935C19.8176 7.11541 20.672 7.11935 21.5816 7.11935C21.4359 6.89491 21.3217 6.69409 21.1879 6.50903C18.9198 3.41413 15.8722 1.86274 12.041 1.97299C9.54064 2.04387 7.3435 2.97706 5.47711 4.65445C3.76822 6.19009 2.64208 8.0801 2.18533 10.3363C1.57501 13.3721 2.15383 16.1717 3.98085 18.6839C5.56767 20.8613 7.69 22.2434 10.3321 22.8143C11.2574 23.0152 12.1985 23.0821 13.1435 23.0191C13.3443 23.0073 13.553 22.9994 13.7499 23.0388C14.2145 23.1333 14.5295 23.5743 14.4941 24.0468C14.4586 24.5193 14.0885 24.8973 13.612 24.9446C13.4506 24.9603 13.2892 24.9761 13.1317 24.9918C12.6749 24.9918 12.2221 24.9918 11.7653 24.9918C11.4346 24.9524 11.1038 24.9209 10.777 24.8737C8.31213 24.5272 6.13467 23.5428 4.26828 21.893C2.07114 19.9518 0.696943 17.5381 0.192939 14.644C0.110251 14.1754 0.0630005 13.699 0 13.2265C0 12.7382 0 12.2499 0 11.7617Z"
      fill="currentColor"
    />
    <path
      d="M13.4742 8.61558C13.4742 9.85197 13.4663 11.0884 13.4781 12.3247C13.4821 12.7185 13.3561 13.0296 13.0765 13.3052C11.8519 14.5179 10.6313 15.7386 9.41855 16.9592C9.09961 17.2821 8.73736 17.4278 8.29242 17.2703C7.6821 17.0537 7.46553 16.3016 7.85535 15.7819C7.92229 15.6913 8.00498 15.6086 8.08373 15.5299C9.16261 14.4471 10.2454 13.3642 11.3283 12.2893C11.4661 12.1554 11.5251 12.0216 11.5251 11.8247C11.5173 9.48184 11.5212 7.13901 11.5212 4.79618C11.5212 4.2843 11.7496 3.92205 12.1551 3.77242C12.8009 3.53617 13.4624 4.0008 13.4703 4.71349C13.4781 5.66637 13.4742 6.61532 13.4742 7.5682C13.4742 7.9147 13.4742 8.26514 13.4742 8.61558Z"
      fill="currentColor"
    />
    <path
      d="M17.2779 23.9878C16.8211 23.9602 16.4471 23.6609 16.3329 23.2199C16.2305 22.8104 16.4077 22.3773 16.7936 22.1607C17.1046 21.9875 17.4236 21.8221 17.7504 21.6764C18.2347 21.4599 18.786 21.6567 19.0183 22.1174C19.2545 22.5821 19.097 23.1372 18.6285 23.405C18.3174 23.5822 17.9945 23.7357 17.6717 23.8854C17.5535 23.9444 17.4118 23.9562 17.2779 23.9878Z"
      fill="currentColor"
    />
    <path
      d="M22.5896 15.7307C22.6802 15.4197 22.7786 14.9393 22.9637 14.4943C23.137 14.0691 23.6567 13.8919 24.1016 14.0297C24.5466 14.1675 24.8419 14.6007 24.7632 15.0653C24.6923 15.4708 24.5899 15.8764 24.456 16.2662C24.2985 16.723 23.83 16.9395 23.326 16.8411C22.8968 16.7545 22.5857 16.3529 22.5896 15.7307Z"
      fill="currentColor"
    />
    <path
      d="M22.818 19.3848C22.7195 19.5935 22.6486 19.814 22.5226 20.003C22.3573 20.251 22.1525 20.4755 21.9596 20.7078C21.5934 21.1449 21.0146 21.2197 20.5893 20.8929C20.1523 20.5542 20.0774 19.9675 20.4279 19.5068C20.6366 19.2273 20.861 18.9556 21.0933 18.6997C21.3689 18.3965 21.7981 18.3098 22.1643 18.4634C22.5266 18.613 22.7589 18.9595 22.818 19.3848Z"
      fill="currentColor"
    />
  </SvgIcon>
)

export const IconDoors = (p: IconProps) => (
  <SvgIcon {...p} viewBox="0 0 25 23">
    <path
      d="M17.7897 13.2757L18.5145 13.8593L19.7196 12.3632L18.5145 10.8654L17.7897 11.449L18.1736 11.9259H15.0746V12.8556H18.1288L17.7897 13.2757Z"
      fill="currentColor"
    />
    <path
      d="M7.20859 13.2757L6.82466 12.8005H9.92534V11.8708H6.86943L7.20859 11.449L6.4855 10.8654L5.27863 12.3632L6.4855 13.8593L7.20859 13.2757Z"
      fill="currentColor"
    />
    <path
      d="M0.929688 0.929688H24.0703V21.2175H22.4227V2.5773H2.5773V21.2175H0.929688V0.929688ZM21.493 21.2175H12.964V3.50699H21.4913V21.2175H21.493ZM12.0343 21.2175H3.50699V3.50699H12.0343V21.2175ZM0 22.1472H25V0H0V22.1472Z"
      fill="currentColor"
    />
  </SvgIcon>
)

export const IconOrganizer = (p: IconProps) => (
  <SvgIcon {...p} viewBox="0 0 25 29">
    <path
      d="M13.9469 28.7873C13.7069 28.7873 13.5053 28.5857 13.5053 28.3457V0.950817L5.72073 1.97789V28.3457C5.72073 28.5857 5.51916 28.7873 5.27919 28.7873C5.03922 28.7873 4.83765 28.5857 4.83765 28.3457V1.58913C4.83765 1.36356 5.00083 1.18119 5.2216 1.15239L13.8893 0.0101369C14.0141 -0.0090606 14.1437 0.0341339 14.2396 0.115723C14.3356 0.197313 14.3932 0.322097 14.3932 0.446881V28.3457C14.3884 28.5953 14.1868 28.7873 13.9469 28.7873Z"
      fill="currentColor"
    />
    <path
      d="M6.84864 6.71969C6.63267 6.71969 6.4359 6.55651 6.4119 6.33094C6.3831 6.09097 6.55108 5.8702 6.80065 5.8414L11.9168 5.22708C12.1568 5.19829 12.3775 5.36627 12.4063 5.61583C12.4351 5.8558 12.2671 6.07657 12.0176 6.10537L6.90144 6.71969C6.88224 6.71969 6.86784 6.71969 6.84864 6.71969Z"
      fill="currentColor"
    />
    <path
      d="M6.84865 4.23848C6.63267 4.23848 6.4359 4.0753 6.4119 3.84973C6.3831 3.60976 6.55108 3.38418 6.79585 3.35539L11.912 2.70267C12.152 2.67388 12.3775 2.84185 12.4063 3.08662C12.4351 3.32659 12.2672 3.55216 12.0224 3.58096L6.90624 4.22888C6.88224 4.23848 6.86784 4.23848 6.84865 4.23848Z"
      fill="currentColor"
    />
    <path
      d="M6.84888 9.17219C6.62331 9.17219 6.43613 8.99941 6.41214 8.77864C6.38814 8.53867 6.56092 8.3179 6.80568 8.2891L11.9218 7.74197C12.1618 7.71797 12.3826 7.89075 12.4114 8.13552C12.4354 8.37549 12.2626 8.59626 12.0178 8.62506L6.90167 9.17219C6.87768 9.17219 6.86808 9.17219 6.84888 9.17219Z"
      fill="currentColor"
    />
    <path
      d="M6.84874 11.6296C6.62317 11.6296 6.4312 11.4568 6.4072 11.2264C6.3832 10.9864 6.56078 10.7657 6.81035 10.7417L11.9265 10.2569C12.1665 10.2329 12.3872 10.4105 12.4112 10.6601C12.4352 10.9 12.2577 11.1208 12.0081 11.1448L6.89194 11.6296C6.87754 11.6296 6.86314 11.6296 6.84874 11.6296Z"
      fill="currentColor"
    />
    <path
      d="M6.84879 14.082C6.61842 14.082 6.43124 13.9044 6.40724 13.6741C6.38804 13.4341 6.56562 13.2133 6.81519 13.1941L11.9313 12.7766C12.1713 12.7574 12.3921 12.9349 12.4113 13.1845C12.4305 13.4245 12.2529 13.6453 12.0033 13.6645L6.88718 14.082C6.87278 14.082 6.86318 14.082 6.84879 14.082Z"
      fill="currentColor"
    />
    <path
      d="M6.84875 16.5345C6.61838 16.5345 6.42641 16.3569 6.40721 16.1217C6.38801 15.8818 6.57039 15.6658 6.81996 15.6514L11.9361 15.2914C12.1761 15.2722 12.392 15.4546 12.4064 15.7042C12.4256 15.9441 12.2433 16.1601 11.9937 16.1745L6.87755 16.5345C6.87275 16.5345 6.86315 16.5345 6.84875 16.5345Z"
      fill="currentColor"
    />
    <path
      d="M6.84858 18.9965C6.61821 18.9965 6.41664 18.8141 6.40704 18.579C6.39744 18.339 6.57982 18.123 6.82459 18.1134L11.9407 17.8207C12.1903 17.8111 12.3967 17.9935 12.4063 18.2382C12.4159 18.4782 12.2335 18.6942 11.9887 18.7038L6.87258 18.9965C6.86778 18.9917 6.86298 18.9965 6.84858 18.9965Z"
      fill="currentColor"
    />
    <path
      d="M6.84857 21.449C6.6134 21.449 6.41663 21.2666 6.40703 21.0267C6.39743 20.7867 6.58461 20.5803 6.82938 20.5659L11.9455 20.3356C12.1855 20.326 12.3919 20.5131 12.4063 20.7579C12.4159 20.9979 12.2287 21.2042 11.9839 21.2186L6.86777 21.449C6.86297 21.449 6.85337 21.449 6.84857 21.449Z"
      fill="currentColor"
    />
    <path
      d="M6.84868 23.8199C6.60871 23.8199 6.41193 23.6231 6.40713 23.3832C6.40233 23.1432 6.59431 22.9368 6.84388 22.9368L11.96 22.8504C12.2 22.8456 12.4064 23.0376 12.4064 23.2872C12.4112 23.5271 12.2192 23.7335 11.9696 23.7335L6.85347 23.8199C6.85347 23.8199 6.85347 23.8199 6.84868 23.8199Z"
      fill="currentColor"
    />
    <path
      d="M13.9328 28.7873C13.6928 28.7873 13.4912 28.5857 13.4912 28.3457V0.446916C13.4912 0.312533 13.5488 0.187749 13.6544 0.0965611C13.76 0.0149716 13.8944 -0.0234235 14.0239 0.0149716L19.0153 1.15723C19.2169 1.20522 19.3561 1.3828 19.3561 1.58917V19.87C19.3561 20.11 19.1545 20.3116 18.9145 20.3116C18.6745 20.3116 18.473 20.11 18.473 19.87V1.93953L14.3695 1.00364V28.3457C14.3743 28.5953 14.1775 28.7873 13.9328 28.7873Z"
      fill="currentColor"
    />
    <path
      d="M24.5585 28.9073H0.441543C0.201574 28.9073 0 28.7057 0 28.4657C0 28.2257 0.201574 28.0242 0.441543 28.0242H24.5585C24.7984 28.0242 25 28.2257 25 28.4657C25 28.7057 24.808 28.9073 24.5585 28.9073Z"
      fill="currentColor"
    />
    <path
      d="M18.8857 4.33436C18.8569 4.33436 18.8281 4.33436 18.7993 4.32957L15.8573 3.75364C15.6173 3.70564 15.4638 3.47527 15.507 3.2353C15.555 2.99534 15.7853 2.84176 16.0253 2.88495L18.9673 3.46088C19.2073 3.50887 19.3609 3.73924 19.3177 3.97921C19.3225 3.02413 19.0921 4.33436 18.8857 4.33436Z"
      fill="currentColor"
    />
    <path
      d="M18.8857 6.82057C18.8569 6.82057 18.8281 6.82057 18.7993 6.81577L15.8573 6.23984C15.6173 6.19185 15.4638 5.96148 15.507 5.72151C15.555 5.48154 15.7853 5.32796 16.0253 5.37116L18.9673 5.94708C19.2073 5.99508 19.3609 6.22545 19.3177 6.46542C19.2745 6.67179 19.0921 6.82057 18.8857 6.82057Z"
      fill="currentColor"
    />
    <path
      d="M18.8854 9.23937C18.8614 9.23937 18.8326 9.23937 18.8086 9.23457L15.8666 8.71624C15.6266 8.67305 15.4634 8.44268 15.5066 8.20271C15.5498 7.96274 15.7802 7.79956 16.0202 7.84275L18.9622 8.36109C19.2022 8.40428 19.3653 8.63465 19.3221 8.87462C19.2789 9.09059 19.0966 9.23937 18.8854 9.23937Z"
      fill="currentColor"
    />
    <path
      d="M18.8859 11.663C18.8619 11.663 18.8379 11.663 18.8139 11.6582L15.8719 11.1975C15.6319 11.1639 15.4639 10.9335 15.5023 10.6887C15.5407 10.444 15.7663 10.2808 16.011 10.3192L18.9531 10.7799C19.193 10.8135 19.361 11.0439 19.3226 11.2887C19.2842 11.5094 19.097 11.663 18.8859 11.663Z"
      fill="currentColor"
    />
    <path
      d="M18.8859 14.1491C18.8619 14.1491 18.8379 14.1491 18.8139 14.1443L15.8719 13.6836C15.6319 13.65 15.4639 13.4196 15.5023 13.1748C15.5407 12.9301 15.7663 12.7669 16.011 12.8053L18.9531 13.266C19.193 13.2996 19.361 13.53 19.3226 13.7748C19.2842 13.9859 19.097 14.1491 18.8859 14.1491Z"
      fill="currentColor"
    />
    <path
      d="M18.8859 16.6304C18.8619 16.6304 18.8379 16.6304 18.8139 16.6256L15.8719 16.1649C15.6319 16.1313 15.4639 15.9009 15.5023 15.6562C15.5359 15.4162 15.7663 15.2482 16.011 15.2866L18.9531 15.7473C19.193 15.7809 19.361 16.0113 19.3226 16.2561C19.2842 16.472 19.097 16.6304 18.8859 16.6304Z"
      fill="currentColor"
    />
    <path
      d="M18.8855 18.9966C18.8663 18.9966 18.8519 18.9966 18.8327 18.9918L15.8907 18.651C15.6507 18.6222 15.4731 18.4014 15.5019 18.1615C15.5307 17.9215 15.7515 17.7439 15.9914 17.7727L18.9335 18.1135C19.1734 18.1423 19.351 18.363 19.3222 18.603C19.2982 18.8238 19.1062 18.9966 18.8855 18.9966Z"
      fill="currentColor"
    />
    <path
      d="M16.9846 27.501C16.951 27.501 16.9126 27.4962 16.879 27.4914C16.0727 27.2947 15.5063 26.5844 15.5063 25.7445C15.5063 25.2597 15.6935 24.8134 16.0247 24.4822C15.9431 24.2807 15.8951 24.0695 15.8951 23.8487C15.8951 23.2728 16.2023 22.7496 16.6774 22.4617C16.6534 22.3609 16.6438 22.2553 16.6438 22.1449C16.6438 21.3914 17.2581 20.7771 18.0116 20.7771C18.5732 20.7771 19.0675 21.1179 19.2739 21.6218C20.0034 21.7754 20.5553 22.4281 20.5553 23.2104C20.5553 23.3976 20.5265 23.5895 20.4593 23.7575C20.9489 24.1223 21.208 24.6886 21.232 25.4613C21.256 26.354 20.5601 27.2803 19.7442 27.4434C19.5042 27.4914 19.2739 27.3379 19.2211 27.1027C19.1731 26.8627 19.3267 26.6323 19.5618 26.5796C19.9506 26.498 20.3585 25.9364 20.3393 25.4901C20.3153 24.7078 19.9986 24.4678 19.6914 24.3382C19.5666 24.2854 19.4658 24.1751 19.437 24.0455C19.4034 23.9111 19.4322 23.7671 19.5138 23.6615C19.6146 23.5319 19.6674 23.3784 19.6674 23.2152C19.6674 22.8072 19.3363 22.4857 18.9379 22.4761H18.9331C18.7075 22.4761 18.5156 22.3129 18.4916 22.0873C18.4628 21.8474 18.2564 21.6698 18.0116 21.6698C17.7477 21.6698 17.5269 21.8858 17.5269 22.1545C17.5269 22.2601 17.5605 22.3561 17.6229 22.4425C17.7093 22.5625 17.7333 22.7209 17.6805 22.86C17.6277 22.9992 17.5077 23.1096 17.3637 23.1384C17.0278 23.2104 16.7878 23.5175 16.7878 23.8583C16.7878 24.0311 16.8406 24.1895 16.9462 24.319C17.0278 24.4198 17.0566 24.5494 17.0326 24.6742C17.0086 24.799 16.9366 24.9094 16.8262 24.9766C16.5526 25.1397 16.3894 25.4325 16.3894 25.7541C16.3894 26.1764 16.6774 26.5364 17.0853 26.6371C17.3205 26.6947 17.4693 26.9299 17.4117 27.1699C17.3589 27.3667 17.1861 27.501 16.9846 27.501Z"
      fill="currentColor"
    />
    <path
      d="M22.4513 25.5717C22.3985 25.5717 22.3505 25.5717 22.2977 25.5669C22.0578 25.5429 21.8802 25.3269 21.9042 25.0821C21.9282 24.8421 22.1442 24.6646 22.3889 24.6886C22.4321 24.6934 22.4705 24.6934 22.5089 24.6886C22.6673 24.6694 22.8161 24.5926 22.9217 24.4726C23.0272 24.3478 23.0752 24.1894 23.056 24.0311C23.0368 23.8199 22.9073 23.6375 22.7153 23.5415C22.6049 23.4887 22.5137 23.3831 22.4801 23.2584C22.4465 23.1336 22.4705 23.004 22.5377 22.8984C22.5809 22.8312 22.6241 22.7352 22.6145 22.5912C22.5905 22.3753 22.4177 22.1881 22.2017 22.1689C22.053 22.1497 21.9234 22.0585 21.8514 21.9193C21.7842 21.7849 21.7938 21.6266 21.8706 21.497C21.8946 21.4634 21.9186 21.401 21.9042 21.3242C21.8946 21.1706 21.7554 21.0602 21.6018 21.0746C21.4674 21.0842 21.3523 21.2042 21.3523 21.3386C21.3475 21.5642 21.1747 21.7465 20.9491 21.7705C20.9443 21.7705 20.9443 21.7705 20.9395 21.7705C20.6995 21.7897 20.4836 21.6122 20.4692 21.3674C20.4644 21.3194 20.4692 21.2714 20.4788 21.2282C20.5364 20.6859 20.9683 20.2491 21.525 20.1963C22.1634 20.1388 22.7297 20.6043 22.7921 21.2426C22.7969 21.3098 22.7969 21.377 22.7921 21.4442C23.176 21.6554 23.4544 22.0537 23.4928 22.5048C23.512 22.6632 23.4928 22.8216 23.4496 22.9752C23.7231 23.2248 23.8911 23.5607 23.9295 23.9351C23.9631 24.3286 23.8479 24.7174 23.5936 25.0245C23.3392 25.3317 22.9792 25.5189 22.5857 25.5621C22.5473 25.5669 22.4993 25.5717 22.4513 25.5717Z"
      fill="currentColor"
    />
    <path
      d="M11.2499 28.8928C11.01 28.8928 10.8084 28.6912 10.8084 28.4513V26.3347H8.00076V28.4513C8.00076 28.6912 7.79919 28.8928 7.55922 28.8928C7.31925 28.8928 7.11768 28.6912 7.11768 28.4513V25.8932C7.11768 25.6532 7.31925 25.4517 7.55922 25.4517H11.2499C11.4899 25.4517 11.6915 25.6532 11.6915 25.8932V28.4513C11.6915 28.696 11.4899 28.8928 11.2499 28.8928Z"
      fill="currentColor"
    />
    <path
      d="M2.8844 27.3859C2.8652 27.3859 2.8508 27.3859 2.8364 27.3859C1.79014 27.2659 1.06543 26.5412 1.06543 25.6102C1.06543 25.1398 1.24781 24.7031 1.56457 24.3767C1.48298 24.1799 1.43978 23.9736 1.43978 23.7672C1.43978 23.2057 1.74214 22.6921 2.20288 22.409C2.17889 22.3082 2.16929 22.2074 2.16929 22.1066C2.16929 21.3675 2.76921 20.7676 3.50832 20.7676C4.05545 20.7676 4.54018 21.1035 4.74656 21.5883C4.96253 21.6363 5.1689 21.7275 5.36088 21.8666C5.55766 22.0154 5.59605 22.289 5.44727 22.4858C5.29849 22.6825 5.02492 22.7209 4.82815 22.5721C4.70816 22.4858 4.56418 22.4378 4.4154 22.433C4.4106 22.433 4.4106 22.433 4.4058 22.433C4.18023 22.433 3.99305 22.2698 3.96906 22.0442C3.94026 21.8138 3.74349 21.6411 3.51312 21.6411C3.25875 21.6411 3.05717 21.8474 3.05717 22.097C3.05717 22.1978 3.08597 22.2938 3.14356 22.3706C3.22995 22.4906 3.25395 22.6489 3.20116 22.7881C3.14836 22.9273 3.02838 23.0377 2.8844 23.0665C2.56764 23.1385 2.32767 23.4264 2.32767 23.7576C2.32767 23.916 2.38046 24.0696 2.48125 24.1991C2.56284 24.2999 2.59163 24.4295 2.56764 24.5543C2.54364 24.6791 2.47165 24.7895 2.36126 24.8567C2.1021 25.015 1.94372 25.2934 1.94372 25.6006C1.94372 25.9893 2.25088 26.4213 2.92759 26.498C3.16756 26.5268 3.34514 26.7476 3.31634 26.9876C3.29714 27.218 3.10997 27.3859 2.8844 27.3859Z"
      fill="currentColor"
    />
  </SvgIcon>
)

// Estrella de contorno del componente `icon_star` del proyecto de diseño
// (Figma node 5388:235, specs/046-valoraciones-bazaarvoice-bd) — trazado real
// exportado desde Figma, no una aproximación genérica.
export const IconStar = (p: IconProps) => (
  <SvgIcon {...p} viewBox="0 0 36 36">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21.8951 13.863L18 1.875L14.1049 13.863H1.5L11.6976 21.2719L7.80244 33.2599L18 25.8509L28.1976 33.2599L24.3024 21.2719L34.5 13.863H21.8951ZM28.9602 15.663H20.5873L18 7.69992L15.4127 15.663H7.03983L13.8136 20.5844L11.2262 28.5474L18 23.626L24.7738 28.5474L22.1864 20.5844L28.9602 15.663Z"
      fill="currentColor"
    />
  </SvgIcon>
)

export const IconMapPin = (p: IconProps) => (
  <SvgIcon {...p} viewBox="0 0 16 22">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.81294 4.09945C5.76901 4.09945 4.11207 5.75129 4.11207 7.78895C4.11207 9.8266 5.76901 11.4785 7.81294 11.4785C9.85687 11.4785 11.5138 9.8266 11.5138 7.78895C11.5138 5.75129 9.85687 4.09945 7.81294 4.09945ZM5.3457 7.78895C5.3457 6.43051 6.45032 5.32928 7.81294 5.32928C9.17556 5.32928 10.2802 6.43051 10.2802 7.78895C10.2802 9.14739 9.17556 10.2486 7.81294 10.2486C6.45032 10.2486 5.3457 9.14739 5.3457 7.78895Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.81294 0C5.74215 0 3.75525 0.852947 2.28965 2.37265C0.823964 3.89244 0 5.95439 0 8.10504C0 11.2559 1.95077 14.7199 3.88861 17.3867C4.85912 18.7223 5.82946 19.8619 6.55712 20.6677C6.88354 21.0292 7.16119 21.3235 7.3682 21.5382L7.81294 21.9996L8.25768 21.5382C8.46469 21.3235 8.74234 21.0292 9.06877 20.6677C9.79642 19.8619 10.7668 18.7223 11.7373 17.3867C13.6751 14.7199 15.6259 11.2559 15.6259 8.10504C15.6259 5.95439 14.8019 3.89244 13.3362 2.37265C11.8706 0.852947 9.88373 0 7.81294 0ZM3.17893 3.22502C4.41723 1.94101 6.08528 1.22983 7.81294 1.22983C9.5406 1.22983 11.2087 1.94101 12.447 3.22502C13.687 4.51082 14.3923 6.26534 14.3923 8.10504C14.3923 10.8339 12.6608 14.0194 10.7383 16.6652C9.79984 17.9566 8.85894 19.062 8.15196 19.8448C8.03161 19.9781 7.9182 20.1018 7.81294 20.2153C7.70768 20.1018 7.59428 19.9781 7.47392 19.8448C6.76694 19.062 5.82604 17.9566 4.88763 16.6652C2.96506 14.0194 1.23362 10.8339 1.23362 8.10504C1.23362 6.26534 1.93891 4.51082 3.17893 3.22502Z"
      fill="currentColor"
    />
  </SvgIcon>
)

// El `clipPath` que exporta Figma recorta al propio viewBox (20×20), así que no
// se conserva: sería un no-op y, al vivir su `id` en el ámbito global del
// documento, se duplicaría en cada icono pintado en la misma página.
export const IconInfo = (p: IconProps) => (
  <SvgIcon {...p} viewBox="0 0 20 20">
    <path
      d="M10.0005 5.28125C10.3913 5.28125 10.7081 5.59802 10.7081 5.9888C10.7081 6.37956 10.3913 6.69634 10.0005 6.69634C9.60976 6.69634 9.29297 6.37956 9.29297 5.9888C9.29297 5.59802 9.60976 5.28125 10.0005 5.28125Z"
      fill="currentColor"
    />
    <path d="M10.5657 9.05859V14.719H9.43359V9.05859H10.5657Z" fill="currentColor" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0ZM1.13208 10C1.13208 5.10238 5.10238 1.13208 10 1.13208C14.8976 1.13208 18.8679 5.10238 18.8679 10C18.8679 14.8976 14.8976 18.8679 10 18.8679C5.10238 18.8679 1.13208 14.8976 1.13208 10Z"
      fill="currentColor"
    />
  </SvgIcon>
)
